// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body > iframe {
  display: none;
}

@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
  .rotate-90 {
    /* transform: rotate(90deg); */
    /* size: A5 landscape; Set A5 paper in landscape mode */
    margin: 0; /* Remove margins */
  }
  @page {
    /* size: A5 landscape; */
    margin: 0; /* Remove margins */
  }
  body {
    margin: 0;
    padding: 0;
    /* width: 210mm; A5 width in landscape orientation */
    /* height: 148mm; A5 height in landscape orientation */
  }
}

@media (max-width: 1100px) {
  :root {
    --side-slide-width: 97%;
  }
}
@media (min-width: 1100px) {
  :root {
    --side-slide-width: 1000px;
  }
}

:root {
  --font-print: 12px;
}
.font-print {
  font-size: var(--font-print);
}
/* 
bootstrap responsive break points 
xs - 575px
sm - 767
md - 991
lg - 1200
// Large devices (desktops, less than 1200px)
*/
@media (max-width: 575.98px) {
  /* // Extra small devices (portrait phones, less than 576px) */

  :root {
    --font-xbig: 20px;
    --font-big: 20px;
    --font-medium: 10px;
    --font-small: 20px;
    --font-xSmall: 20px;
    --hide-on-sm: none;
    --header-height: 30px;
    --side-nav-left: -100%;
  }
}

@media (max-width: 767.98px) and (min-width: 575.98px) {
  /* // Small devices (landscape phones, less than 768px) */
  :root {
    --font-xbig: 14px;
    --font-big: 12px;
    --font-medium: 11px;
    --font-small: 8px;
    --font-xSmall: 6px;
    --header-height: 30px;
    --side-nav-left: -100%;
  }
}

@media (max-width: 991.98px) and (min-width: 767.98px) {
  :root {
    --font-xbig: 20px;
    --font-big: 20px;
    --font-medium: 13px;
    --font-small: 20px;
    --font-xSmall: 20px;
    --header-height: 50px;
    --side-nav-left: -220px;
  }
}

@media (min-width: 991.98px) {
  :root {
    --font-xbig: 22px;
    --font-big: 20px;
    --font-medium: 14px;
    --font-small: 10px;
    --font-xSmall: 8px;
    --hide-on-sm: flex;
    --header-height: 50px;
    --side-nav-left: -220px;
  }
}

* {
  transition: 300ms;
}

a {
  color: var(--rf-brand-lite) !important;
  text-decoration: none !important;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  margin: 0;
  overflow-x: hidden;
}
.app-content {
  position: relative;
  z-index: 0;
}
.page-title {
  color: white;
  font-size: var(--font-xbig);
  font-weight: bold;
  margin-left: 200px;
}
.container {
  width: 70%;
  margin-left: 15%;
  font-family: Arial, Helvetica, sans-serif;
}
.message {
  height: 50px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  padding: 5px;
  border-radius: 5px;
  margin-top: 3px;
}
.message.header {
  border-radius: 0px;
  background-color: #c48650;
  color: black;
  font-weight: bold;
  font-size: 16px;
}
.text {
  width: 85%;
}
.date {
  width: 10%;
  text-align: center;
}

.header.simple {
  height: 20px;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--header-height);
  background-color: var(--rf-brand-lite);
  box-shadow: 0px 3px 14px #a6a5a5;
  z-index: 99;
}
.icon-btn {
  height: 30px;
}
.header > .btn-slider {
  width: 50px;
  height: 50px;
  color: white;
  cursor: pointer;
}
.logo.simple {
  left: -3px;
  top: -15px;
  width: 60px;
  aspect-ratio: 1/1;
  border-radius: 50%;
}
.logo.simple > a > img {
  width: auto;
  height: 20px;
}
.logo {
  position: absolute;
  left: 50px;
  top: 0px;
  background-color: white;
  height: calc(var(--header-height) + 10px);
  width: 120px;
  box-shadow: 0px 3px 14px #a6a5a5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo > a > img {
  width: calc(40px + var(--header-height));
}
img.right {
  position: absolute;
  width: 13px;
  right: -14px;
  bottom: -3px;
  z-index: 0;
}

.sideNav {
  position: fixed;
  z-index: 0;
  width: 270px;
  height: 100vh;
  background-color: white;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  padding-top: 100px;
  transition: 400ms;
  left: 0%;
  top: 0;
  z-index: 2;
}
.sideNav.noshow {
  transition: 400ms;
  left: var(--side-nav-left);
}
.sideNav > span.active {
  background-color: #f8f8f8;
}
.sideNav > span {
  padding-left: 10px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
}

.input-forms.stretch {
  width: 100% !important;
}
.input-forms.date-picker > span.label {
  width: 15%;
  font-size: 12px;
  font-weight: bold;
}
.input-forms.flat.height-thin {
  height: 30px !important;
}
.input-forms.flat.height-mid {
  height: 35px !important;
  border-radius: 0px !important;
  background-color: #ffffff !important;
}
.input-forms.flat.height-small {
  border-radius: 0px !important;
  height: 25px !important;
  background-color: #ffffff !important;
}
.input-forms {
  width: 300px;
  height: 35px !important;
}

.text-input.small {
  width: 100px;
}
.text-input.number {
  /* height: 35px !important; */
}
.date-picker.small-btn.flat {
  box-shadow: none !important;
}
.text-input.date-picker {
  margin: 0 !important;
}
.text-input.flat2 {
  border-radius: 0px !important;
  border: 1px solid #eaeaea !important;
  box-shadow: none !important;
  margin: 0px !important;
}
.flat2-btn {
  height: 35px;
}
.text-input.flat {
  border-radius: 0px !important;
  background-color: white !important;
}
.text-input {
  padding: 0px 10px !important;
  /* background-color:#F5F5F5 !important; */
  background-color: white !important;
  /* border-radius: 5px; */
  border-radius: 0px;
  border: none;
  font-size: 12px;
  margin: 15px 0 10px 0;
  padding: 0px;
  /* box-shadow: inset 0px 0px 10px rgba(85, 85, 85, 0.25) */
  box-shadow: 0px 0px 10px rgba(85, 85, 85, 0.25);
}

.text-input.light-border {
  border: 1px solid #d9d8d6;
  box-shadow: none !important;
}

.text-input.red-border {
  border: 1px solid red !important;
}
.text-input.flat-white:focus {
  outline: none !important;
}
.text-input.flat2:focus {
  outline: none !important;
}
.text-input.flat-white {
  background-color: white !important;
  border-radius: 0px;
  border-bottom: 1px solid grey;
  box-shadow: none !important;
  width: auto;
  min-width: 100px;
}
.search.thin {
  height: 30px !important;
  margin: 10px 0px !important;
}
.search > input {
  width: 90%;
  border-radius: 8px 0 0 8px;
  height: 30px !important;
}
.search > span {
  background-color: #f2ece0;
  padding: 0 !important;
  border: none;
  width: 10%;
  min-width: 50px;
  height: 30px;
  border-radius: 0 8px 8px 0;
}
.search {
  width: 500px;
  height: 30px;
}
.text-input.search:focus {
  outline: none !important;
}
.text-input:focus {
  outline: 1px solid var(--rf-brand-lite) !important;
}
.text-input.lime-border,
.text-input.lime-border:focus {
  outline: 1px solid #55b76a !important;
}
.iconed-input {
  position: relative;
}

.iconed-input > span {
  height: 40px;
  width: 30px;
  position: absolute;
  left: calc(100% - 40px);
  top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon.square {
  aspect-ratio: 1/1;
}
.icon.back-red {
  color: #fff;
  background: #b75555;
}
.icon {
  color: var(--rf-brand-lite);
}
.icon.grey {
  color: #6a6a6a !important;
}
.icon.green {
  color: #66b755;
}
.icon.red {
  color: #b75555;
}
.icon.light-red {
  color: #b75555;
}

.dropdown > select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat 100% 50%;
  background-size: 30px 100px;
  padding-left: 10px;
  width: 310px;
  appearance: none;
  outline-width: 0;
}
.dropdown > div {
  width: 20px;
  background-color: black;
}
.fade-text {
  color: #6a6a6a !important;
}

td.checker_img > span {
  position: absolute;
  width: 20px !important;
  right: 15px;
  bottom: 0;
}
td.checker_img > img {
  height: 30px !important;
  width: auto !important;
}

.table-list.product-list.summary.flat > tr > td:nth-child(1) {
  width: 10px !important;
  color: #c48650 !important;
}
.table-list.product-list.summary.flat > tr > td:nth-child(2) {
  width: 90% !important;
  color: #c48650 !important;
}
.table-list.summary.mid-row.flat > tr {
  height: 35px !important;
}
.table-list.summary.small-row.flat > tr {
  height: 20px !important;
}
.table-list.summary.flat.row-xsmall > tr > td:last-child {
  /* border-bottom: none !important; */
}
.table-list.summary.flat.row-xsmall > tr {
  height: 20px !important;
}
.table-list.summary.flat > tr {
  background-color: white !important;
}
.table-list.summary.flat > tr > td:nth-child(1) {
  width: auto !important;
  color: #c48650 !important;
  text-wrap: nowrap;
}
.table-list.summary.flat > tr > td,
th {
  border: none !important ;
  border-bottom: 1px solid #ededed !important;
}
.table-list.summary {
  width: 100%;
  margin-bottom: 20px;
}
.table-list.summary > tr > td.action-icon {
  width: 30px !important;
}
.table-list.summary > tr > td:nth-child(n + 3) {
  width: 100px;
  font-weight: bold;
}
.table-list.summary.pre > tr > td {
  text-align: center;
  padding: 0 !important;
}

.table-list.summary.pre > tr {
  height: 30px !important;
}
.table-list.pre > tr > td:nth-child(1) {
  width: 40px !important;
}
.table-list.summary.pre > tr > td:nth-child(4) {
  width: auto !important;
  font-size: 10px !important;
}
.table-list.summary.pre > tr > td:nth-child(3) {
  width: auto !important;
  font-size: 10px !important;
}
.table-list.summary.pre > tr > td:nth-child(n + 4) {
  /* border: none !important; */
  width: auto;
}
.table-list.summary > tr > td:nth-child(n + 2) {
  border-left: 2px solid #fff;
}
.table-list.summary > tr > td:nth-child(1) {
  font-weight: bold;
  width: 30%;
}
.table-list.summary > tr > td {
  text-align: left;
  padding-left: 10px;
}
.table-list.summary > thead > tr,
.table-list.summary > tr {
  height: 40px !important;
}
.table-list.summary > tr:nth-child(odd) {
  background-color: #ebebeb;
}
.table-list {
  background-color: rgba(217, 217, 217, 0.1);
  width: 1800px;
  font-size: 12px;
  border-spacing: 0px 20px !important;
  border-collapse: collapse;
  position: relative;
}

.table-list > .head {
  background-color: #eaeaea;
  height: 40px;
}
tr.bt_table.printing > th {
  background-color: #ababab;
}
tr.bt_table > th {
  margin-bottom: none !important;
  text-align: left !important;
  background-color: #6a6a6a;
  color: white;
}
th {
  margin-bottom: 10px !important;
  text-align: center !important;
}
td {
  /* text-align: center; */
}
.light-card {
  /* background-color: #fafafa; */
  border-radius: 8px;
}
tbody.auto > tr > td {
  width: auto !important;
}
/* tbody > tr > td:nth-child(3)  */
tbody.print-wo > tr > td:nth-child(1),
tbody.print-wo > tr > td:nth-child(3) {
  font-weight: bold;
  width: 20% !important;
}

tbody.print-wo.plain > tr > td:nth-child(1),
tbody > tr > td:nth-child(3) {
  font-weight: normal;
  width: auto !important;
}
/* tbody > tr > td:nth-child(4) */
tbody.print-wo > tr > td:nth-child(2) {
  width: 30% !important;
}
/* tbody > tr > td:nth-child(1), tbody > tr > td:nth-child(3){
  font-weight: bold;
} */
.no-wrap {
  text-wrap: nowrap;
}
.table-list > .data {
  height: 45px;
  background-color: white;
  margin-bottom: 2px !important;
  box-shadow: 0px 2px 10px #eaeaea;
}
.table-list > .data:hover {
  box-shadow: 0px 2px 10px #c4c4c4;
  z-index: 4;
}
.row-separator {
  height: 35px;
  color: #6a6a6a;
  font-size: 10px;
}

.iconed-button.small {
  width: 80px;
  height: 25px;
  font-size: 10px;
}

.iconed-button {
  background-color: #eaeaea;
  border: none;
  border-radius: 8px;
}
.iconed-button.small > span.text {
  font-weight: bold;
}

.iconed-button.small > div {
  width: 30px;
}

.iconed-button.small > span.text {
  width: 50px;
}

.time-date {
  width: 160px;
  height: 25px;
  font-size: 11px;
  font-weight: bold;
  background-color: red;
  display: flex;
  justify-content: center;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  z-index: 9;
}
.time-date > div {
  padding-left: 5px;
}
.time-date > .time {
  background-color: var(--rf-brand-lite);
  color: white;
  width: 40%;
}
.time-date > .date {
  background-color: white;
  color: var(--rf-brand-lite);
  width: 60%;
}
.selectable-card.selected {
  background-color: #ecd39c;
  color: white;
  transition: 500ms;
}
.selectable-card.simple {
  height: 40px !important;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
}
.selectable-card > .code,
.selectable-card.detailed > .code {
  width: 100px;
  /* background-color: #6a6a6a; */
  background-color: var(--rf-brand-lite);
  color: white;
  font-weight: bold;
  font-size: 12px !important;
  position: absolute;
  top: 0;
  right: 0;
}
.selectable-card.detailed > .flowers {
  position: absolute;
  bottom: 0;
  right: 30px;
}
.selectable-card.detailed {
  height: 100px;
  margin: 8px 0;
}
.selectable-card {
  cursor: pointer;
  transition: 500ms;
  box-shadow: 0px 2px 6px rgba(117, 117, 117, 0.25);
  width: 100%;
  height: 95px;
  position: relative;
  margin: 2px 0 3px 0;
}
.selectable-card > img {
  transition: 500ms;
  left: -100px;
  /* opacity: 0; */
}
.selectable-card.selected > img {
  transition: 500ms;
  left: 40px;
}
.selectable-card > .product-img.list {
  left: 0;
  height: 95px;
}
.selectable-card > .product-img {
  transition: 500ms;
  height: 55px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  left: 25px;
}
.selectable-card.selected > span {
  opacity: 1;
  transition: 500ms;
  margin-left: 10px;
}
.selectable-card > span {
  opacity: 0;
  transition: 500ms;
}
.selectable-card > .icon {
  transition: 500ms;
  opacity: 0;
}
.selectable-card > .product-img.icon {
  opacity: 1;
  left: 10px;
}
.selectable-card.simple > .text {
  /* width: auto; */
  position: relative !important;
}
.selectable-card > .text {
  position: absolute;
  right: 0px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  width: 80%;
}
.map-marker {
  position: relative;
  width: 200px;
  height: 80px;
  border: 5px solid var(--rf-brand-lite);
  border-radius: 10px;
  box-shadow: 2px 8px 12px rgba(0, 0, 0, 0.2);
}
.map-marker > .time {
  position: relative;
  z-index: 5;
  font-size: 12px;
  font-weight: bold;
}
.map-marker > .items {
  background-color: var(--rf-brand-lite);
  height: 35px;
  margin: 0;
  color: white;
  font-size: 12px;
  font-weight: bold;
}
.map-marker > .edge {
  position: absolute;
  left: calc(50% - 21px);
  bottom: -21px;
  border-bottom: 5px solid var(--rf-brand-lite);
  border-right: 5px solid var(--rf-brand-lite);
  width: 30px;
  height: 30px;
  rotate: 45deg;
}
.map-marker > .edge > div {
  width: 30px;
  height: 30px;
  background-color: white;
}

.button.tile > span.icon {
  background-color: #55b89d !important;
}
.button.tile > p,
.button.green > p {
  color: #fff !important;
}
.button.green > span.icon {
  background-color: #66bb6a !important;
}
.button.green.form,
.button.tile.form {
  /* box-shadow: 0px 0px 8px rgba(183, 233, 186) !important; */
  background-color: #b7e9ba;
}
.button.cancel {
  /* background-color: #FBE7E7; */
  color: rgb(255, 123, 123) !important;
}
.button {
  position: relative;
  background-color: #eaeaea;
  border: none;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
}
.button:hover {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}
.button > p {
  /* width: 100%; */
  font-size: var(--font-small);
  font-weight: bold;
}
.button > .icon {
  /* position: absolute; */
  height: 80px;
  width: 5%;
  /* min-width: 30px; */
}

.button.form.thin > p,
.button.form.thin,
.button.form.thin > .icon {
  height: 25px !important;
}
.button.form.thin > .icon {
  background-color: #6a6a6a;
}

.button.form {
  height: 30px;
  margin: 10px 0 10px 0;
  box-shadow: none !important;
}
.button.form > p {
  padding: 3px 10px;
  color: #6a6a6a;
  height: 30px;
}
.button > .icon.right {
  right: 0 !important;
}
.button > .icon.left {
  left: 0 !important;
}
.button.form > .icon {
  /* position: absolute; */
  height: 30px;
  width: 15%;
  min-width: 30px;
  padding: 0 10px 0 10px;
  background-color: #cbcbcb;
}
.button.large > p {
  /* height: 80px; */
}
.button.large {
  width: 300px;
  height: 80px;
  border-radius: 10px;
}
.button.mid {
  width: 175px;
  height: 36px;
  border-radius: 10px;
}
.button.disabled.light {
  color: #a2a2a2 !important;
  background-color: #eaeaea !important;
}
.button.disabled {
  background-color: #c0c0c0 !important;
  cursor: not-allowed;
}
.button.flat.form {
  height: 35px;
}
.button.flat.thin-flat.green {
  background-color: #55b76d;
  color: white;
}
.button.flat.thin-flat.warnning-btn {
  background-color: rgb(255, 210, 210);
  color: #b75555;
}
.button.flat.thin-flat {
  height: 30px;
}

.button.flat {
  box-shadow: none !important;
  border-radius: none !important;
  height: 50px;
  color: rgb(106, 105, 105);
}
.order-type {
  display: flex;
  justify-content: space-around;
}
.login-form {
  width: 310px;
  height: 100vh;
  /* background-color: grey; */
  padding-top: 100px;
}
.login-form > img {
  margin-bottom: 100px;
  width: 260px;
}
.labeled-checkbox {
  height: 30px;
  font-weight: bold;
  font-size: 12px;
}
.labeled-checkbox.mid > input {
  width: 15px;
}
.labeled-checkbox.large > input {
  width: 15px;
}
.labeled-checkbox > input {
  border: none !important;
  margin-right: 10px;
  aspect-ratio: 1/1;
  cursor: pointer;
}
.login-form > div {
  font-size: 12px;
  color: #a89d9d;
  font-weight: bold;
  margin-bottom: 10px;
}
.order-type-select > h3 {
  margin-bottom: 100px;
}
.order-type-select {
  width: 900px;
  height: 100vh;
  padding-top: 100px;
}
.data-input {
  margin-top: 60px;
  width: 93%;
}

.data-input > .datas {
  width: 95%;
}
.summary > .datas {
  width: 100%;
  padding: 10px 20px 0 20px;
}
.data-row {
  /* background-color: rgb(190, 189, 189); */
  min-height: 200px;
  /* width: 300px; */
}
.actions > button > * {
  height: 34px !important;
}
.actions > button {
  width: 200px;
  height: 36px !important;
}
.actions {
  margin-top: 200px !important;
  width: 80%;
}
.select-options {
  position: fixed;
  top: 65px;
  left: 80px;
  width: 95%;
  min-height: calc(100vh - 220px);
  z-index: 19;
  background-color: white;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
}
.select-options > .title > h4 {
  height: 50px;
  color: white;
  font-weight: bold;
}
.select-options > .title {
  padding: 0 -5px 0 -5px !important;
  background-color: #6a6a6a;
  height: 50px;
}
.title {
  color: white;
  font-weight: bold;
  padding: 0px !important;
  background-color: var(--rf-brand-lite);
  height: 80px;
}
.title.thin {
  background-color: #6a6a6a;
  height: 40px;
}
.border-rad-top-LR {
  border-radius: 10px 10px 0 0 !important;
  overflow: hidden;
}
.select-options > div > .search {
  margin: 10px 0 30px 0;
}
.price-tag {
  background-color: #fff3da;
  width: auto;
  height: auto;
  border-radius: 10px;
  padding: 5px 0px;
}
.price-tag > div > .msg {
  width: 40%;
  height: auto;
  font-size: 12px;
  text-align: left;
  padding-left: 12px;
}
.price-tag > div > .pricetot {
  font-size: var(--font-xbig) !important;
  font-weight: bold;
}

.price-tag > div > .price {
  font-size: var(--font-big);
  height: auto;
  width: 60%;
  text-align: right;
  padding-right: 12px;
}

.related-results.hover {
  position: absolute;
}
.related-results {
  position: relative;
  min-height: 10px;
  width: 100%;
  font-size: 12px;
  margin-bottom: 15px;
  margin-top: -12px;
  z-index: 5;
  padding: 15px 0 20px 0;
  background-color: #efefef;
  /* background-color: #a6a5a5; */
}
.search-result-row:hover {
  background: #f3f3f3;
}
.search-result-row {
  font-size: 13px;
  background-color: white;
  margin: 0px 0px 3px 0px !important;
  /* padding-bottom: ; */
}
label.input.focused {
  opacity: 1;
  top: -4px;
  transition: 400ms;
}
label.input {
  transition: 400ms;
  font-size: 12px;
  opacity: 0;
  font-weight: bold;
  color: #c48650;
  position: absolute;
  top: 0px;
  left: 5px;
}
.icon-link {
  position: absolute;
  right: 0;
  height: 42px;
  background-color: #856a52;
  width: 23px !important;
  padding: 0 !important;
}

div.type {
  height: 20px;
  position: absolute;
  right: 5px;
  bottom: 5px;
  border-radius: 5px;
  padding: 4px 10px;
  background-color: #c48650;
  color: white;
}
.xlight-lime-bg {
  background-color: #b4f8c0 !important;
}
.xlight-gold-bg {
  background-color: #f6ecd9 !important;
}
.work-order-list {
  background-color: #fafafa;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1) !important;
  min-height: calc(750px);
  padding-bottom: 100px;
}
.table-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #6a6a6a;
  box-shadow: 0px 3px 8px rgba(150, 146, 146, 0.87) !important;
}
.table-head > span {
  padding: 3px 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto !important;
  /* min-height: 40px; */
  font-weight: bold;
  color: white;
  width: 9%;
}
.content-row:hover {
  transition: 400ms;
  /* background: #aef68d; */
  background: #fbf8f0;
  cursor: pointer;
  box-shadow: 0px 4px 15px rgba(157, 157, 157, 0.55) !important;
  /* background-color: #FEF5E1; */
}
.parent-child-detail {
  background: #f5f2f2 !important;
  border-left: 2px solid var(--rf-brand-lite);
}
.product-card > .products {
  display: flex;
  align-items: center;
}
.product-card > .txt {
  background-color: #eaeaea;
  color: #6a6a6a;
  padding: 2px 5px;
}
.product-card {
  min-width: 20% !important;
  display: block;
  text-align: right;
  background-color: #fbf8f0;
  border-top: 2px solid #f9dfa4;
  padding: 0px 10px 0px 0px;
}
.content-row {
  margin: 7px 0px;
}
.content-row > div.lower {
  width: 100%;
  justify-content: end;
}
.product-tag.selected {
  background-color: #55b761;
}
.product-tag.extras {
  background: white;
  border-radius: 0;
}
.product-tag {
  padding: 1px 8px;
  background-color: #c7b691;
  color: white;
  border-radius: 8px;
  margin: 0px 3px;
  white-space: nowrap;
  font-weight: bold;
}
.content-row {
  box-shadow: 0px 3px 10px rgba(157, 157, 157, 0.25) !important;
  background-color: white;
}

.table-row-content {
  transition: 00ms;
  width: calc(100% - 0px);
  cursor: pointer;
  margin-top: 2px;
}
.table-row-content > span {
  /* padding: 8px 40px; */
  height: auto !important;
  min-height: 30px;
  display: flex;
  width: 9%;
  justify-content: center;
  align-items: center;
}
.content-row.active,
.content-row.compact.active {
  border-left: 2px solid #f9dfa4 !important;
  margin-left: 20px !important;
}
.table-row-content.compact {
  height: 40px;
  padding: 0px 10px;
}
.order-side-slide.searchWO > .title {
  background-color: white;
  border-bottom: 1px solid gray;
}
.order-side-slide.searchWO {
  top: 10px;
  width: 600px;
  min-height: calc(100vh - 100px);
}
.order-side-slide.product {
  width: 600px;
  min-height: calc(100vh - 100px);
}
.order-side-slide.flowers {
  width: 700px;
}
.order-side-slide {
  width: var(--side-slide-width);
  position: absolute;
  right: -100%;
  top: 60px;
  transition: 300ms;
  background-color: white;
  z-index: 50;
  min-height: calc(100vh - 60px);
  display: none;
  padding-bottom: 50px;
}
.order-side-slide.shadow-none.active {
  box-shadow: none !important;
}
.order-side-slide.active {
  display: block;
  transition: 300ms;
  right: 10px !important;
  /* box-shadow: -850px 0px 100px rgba(0, 0, 0, 0.2) !important; */
}

.collapsing.card-body {
  opacity: 0;
  transition: 1s;
  height: 0px !important;
  width: 100%;
  display: none;
}
.active.collapsing.card-body {
  /* min-height: 150px !important; */
  height: auto !important;
  transition: 1s;
  opacity: 1;
  display: block;
}
.collapsing > h5 {
  height: 30px !important;
  cursor: pointer;
  font-weight: bold;
}
.collapsing > h5:hover {
  box-shadow: 0px 4px 15px rgba(157, 157, 157, 0.35) !important;
  background-color: #fef5e1;
}
.collapsing {
  border-radius: 0px !important;
  border: none !important;
  margin-top: 2px !important;
  padding: 5px 0px 0px 0px !important;
}
.user-bar {
  cursor: none;
}
.user-bar:hover {
  background-color: white !important;
  box-shadow: 0px 3px 8px rgba(142, 139, 139, 0.1) !important;
}

.toggle-radio {
  width: auto;
  border-radius: 4px;
  overflow: hidden;
  height: 25px;
}
.toggle-radio > a.active {
  background-color: #6a6a6a;
  color: white !important;
}
.toggle-radio > a {
  color: #6a6a6a !important;
  height: 25px;
  width: auto;
  padding: 3px 10px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
}
.product-page {
  width: 90%;
  border: 1px solid #d8d8d8;
  border-radius: 20px;
  margin-top: 70px;
  min-height: calc(100vh - 80px);
  padding: 10px;
}
.product-detail > img {
  height: 200px;
  padding: 10px;
}
.tags {
  /* height: 20px; */
  background-color: #eaeaea;
  color: black !important;
  /* min-width:50px; */
  /* width: auto; */
  padding: 0px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
  margin: 4px 2px;
}
.add-image > span {
  color: grey;
}
.add-image.active > button {
  width: 100px;
  height: 23px;
  border-radius: 6px;
  background-color: var(--rf-brand-lite);
  color: white;
  border: none;
  padding: 0;
}
.add-image.active {
  background-color: white;
}
.add-image > div > img {
  height: 300px;
}
.add-image {
  background-color: #f2f0f0;
  height: 300px;
  aspect-ratio: 2/1;
}
.newcode {
  background-color: var(--rf-brand-lite);
  color: white;
  font-weight: bold;
  padding: 5px 15px;
}
.popup-window > .action-btns {
  position: absolute;
  bottom: 0;
}
.popup-window {
  width: 500px;
  min-height: 300px;
  background: white;
}
.blur-bg {
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}
.fullscreen {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
.popup.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
}
.collapsable-user-display.active {
  height: 150px;
}
.collapsable-user-display > div > img {
  height: 60px;
  border-radius: 50%;
}
.collapsable-user-display {
  width: 100%;
  height: 60px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-top: 10px;
}
.collapsable-user-display > .user-detail {
  min-height: 50px;
  width: 100%;
}
.collapsable-user-display > .user-detail > p {
  margin-top: 20px !important;
}
.collapsable-user-display > .user-detail > div > div {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: left;
}
.checker_img {
  width: 90px;
}

.pagenation {
  width: 100%;
  height: 24px;
  margin-top: -50px;
  position: relative;
}

.pagenation > div > div.page-btn:hover {
  background: #dfc48a;
}
.pagenation > div > div.page-btn.active {
  background: #6a6a6a;
}
.pagenation > div > div.page-btn {
  cursor: pointer;
  width: 24px;
  height: 24px;
  background-color: #b7b7b7;
  margin: 0px 0px;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-small);
  margin: 0px 2px;
  border-radius: 50%;
}
.next,
.prev {
  cursor: pointer;
  width: 5%;
  background-color: #6a6a6a;
  color: white;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagenation > .pages {
  width: 90%;
}
.wo-filter-tools > div {
  margin: 5px 3px;
}
.wo-filter-tools {
  width: var(--width-lg25-md50-lg-100);
}

.drag-drop-area > div.action {
  position: absolute;
  right: 0;
  top: 0px;
  height: 40px;
  margin-right: 5px;
}

.drag-drop-area > div.action > button {
  border: none;
  background-color: #66b755;
  padding: 3px 10px;
  color: white;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
  height: 40px;
  margin-right: 30px;
}
.drag-drop-area.detail {
  width: 100%;
  position: relative;
}
.drag-drop-area.movable {
  width: var(--side-slide-width);
  position: absolute;
}
.drag-drop-area {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25) !important;
  /* overflow: hidden; */
  /* top: 80px; */
  /* left:40px; */
  background-color: rgba(255, 255, 255, 1);
  /* border: 2px dashed #a4a4a4; */
  min-height: calc(100vh - 100px);
  z-index: 99;
  border-radius: 10px;
  width: 100%;
  /* padding: 0 10px; */
}
.drag-drop-area > div > .body {
  height: calc(100vh - 250px);
}
.drag-drop-area > div > div > .head.page {
  font-size: var(--font-xbig);
}
.drag-drop-area > div > div > .head {
  font-size: var(--font-small);
  height: 40px;
  width: 100%;
  font-weight: bold;
  background-color: #6a6a6a;
  color: white;
  margin-bottom: 20px;
}
.delivery-run-row.head {
  height: auto !important;
  min-height: 25px !important;
  background-color: #8e8e8e;
  color: white;
  margin-top: 20px;
}
.delivery-run-row.touchable:hover {
  background: #f6e9cc;
}

.delivery-run-row.delete {
  opacity: 0;
  background: red !important;
}
.delivery-run-row.print {
  border-bottom: 1px solid black;
}
.delivery-run-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  background: white;
  opacity: 1;
  transition: 
  /* step 1 */ background 1s, /* step 2 */ opacity 0.5s 1s;
}
.delivery-run-row > span {
  text-align: center;
}
.delivery-run-row > span:nth-child(1) {
  width: 1%;
}
.delivery-run-row > span:nth-child(2) {
  width: 8%;
}
.delivery-run-row > span:nth-child(3) {
  width: 15%;
}
.delivery-run-row > span:nth-child(4) {
  width: 8%;
}
.delivery-run-row > span:nth-child(5) {
  width: 15%;
}
.delivery-run-row > span:nth-child(5) {
  width: 20%;
}
.delivery-run-row > span:nth-child(6) {
  width: 5%;
}

.delivery-run-row.detail > span:nth-child(1) {
  width: 10px;
}
.delivery-run-row.detail > span:nth-child(2) {
  width: 5%;
}
.delivery-run-row.detail > span {
  width: 10%;
  font-size: var(--font-small);
}
.delivery-run-row.detail.print > span {
  width: 10%;
  font-size: var(--font-prints);
}
.delivery-run-row.detail > span:nth-child(10) {
  width: 15%;
}

.delivery-run-row.fd-list > span:nth-child(1) {
  width: 1%;
}
.delivery-run-row.fd-list > span:nth-child(2) {
  width: 8%;
}
.delivery-run-row.fd-list > span:nth-child(3) {
  width: 8%;
}
.delivery-run-row.fd-list > span:nth-child(4) {
  width: 10%;
}
.delivery-run-row.fd-list > span:nth-child(5) {
  width: 10%;
}
.delivery-run-row.fd-list > span:nth-child(6) {
  width: 10%;
}
.delivery-run-row.fd-list > span:nth-child(7) {
  width: 10%;
}
.delivery-run-row.fd-list > span:nth-child(8) {
  width: 10%;
}
.delivery-run-row.fd-list > span:nth-child(9) {
  width: 20%;
}
.delivery-run-row.fd-list > span:nth-child(10) {
  width: 5%;
}

.inventory-run-row.head {
  height: 25px !important;
  background-color: #8e8e8e;
  color: white;
  margin-top: 20px;
}

.inventory-run-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  background: white;
  opacity: 1;
  transition: 
    /* step 1 */ background 1s, /* step 2 */ opacity 0.5s 1s;
}
.inventory-run-row > span:nth-child(1) {
  width: 3%;
}
.inventory-run-row > span:nth-child(2) {
  width: 65%;
}
.inventory-run-row > span:nth-child(3) {
  width: 20%;
}

.tooltip-prompt > .corner {
  position: absolute;
  left: 139px;
  bottom: -10px;
  z-index: 0;
  height: 20px;
  aspect-ratio: 1/1;
  background: var(--rf-brand-lite);
  transform: rotate(45deg);
}
.tooltip-prompt {
  position: fixed;
  top: 80px;
  width: 300px;
  background-color: white;
  border-radius: 6px;
  z-index: 99;
}
.tooltip-prompt > div.msg {
  padding: 10px;
  text-align: center;
  background-color: var(--rf-brand-lite);
  color: white;
}
.tooltip-prompt > div > button:hover {
  background-color: #86c579;
  color: white;
}
.tooltip-prompt > div > button {
  background-color: white;
  border: none;
  width: 50%;
  padding: 8px 10px;
  position: relative;
  z-index: 10;
}

.expanding-prompt > div.opts {
  width: 50%;
  transition: 1000ms;
  opacity: 0.5;
  position: relative;
  z-index: 3;
}
.expanding-prompt > div.opts.active {
  opacity: 1;
  transition: 1000ms;
  width: auto;
}
.expanding-prompt {
  position: fixed;
  top: 80px;
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.expanding-prompt > div.msg {
  padding: 10px;
  text-align: center;
  background-color: #6a6a6a;
  color: white;
}
.expanding-prompt > div > button:hover {
  background-color: #86c579;
  color: white;
}
.expanding-prompt > div > button {
  background-color: rgb(255, 248, 232);
  border: none;
  padding: 8px 30px;
}
.loading-div {
  width: 98%;
  height: 30px;
  margin: 3px 1%;
}

.run-detail.active > div {
  box-shadow: -50px -2px 180px rgba(0, 0, 0, 0.2) !important;
}

.run-detail.active {
  right: 0;
  transition: 300ms;
  top: 0;
  opacity: 1;
}

.run-detail {
  position: absolute;
  right: -100%;
  top: 0;
  transition: 300ms;
  opacity: 0;
}
.loading-wait {
  width: 40px !important;
}
.wait-box {
  border-radius: 50%;
  background-color: white;
  aspect-ratio: 1/1;
  animation: wait 1s infinite;
}
@keyframes wait {
  from {
    width: 3px;
  }
  to {
    width: 6px;
  }
}
.reload-display {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 200px;
  margin-top: 50px;
}

@media print {
  .print-page {
    left: 0 !important;
    width: 100% !important;
    margin: 0px !important;
  }
  .the-print-page {
    left: 0 !important;
    width: 100% !important;
  }
  .no-print,
  .no-print * {
    display: none !important;
  }
}

.print-page {
  position: absolute;
  left: 5%;
  top: 5px;
  width: 90%;
  /* aspect-ratio: 1.4142/1; */
  /* aspect-ratio: 1/1; */
  min-height: calc(100vh - 100px);
  background-color: white;
  /* z-index: 100; */
  font-size: var(--font-small);
}
.print-page > div > div > div > div.head.page > span.date {
  height: 40px;
  min-width: 200px;
  padding: 0px 10px;
  color: black;
  margin-left: 35px;
  background-color: white;
}
.print-page > div > div > div > .head {
  border-radius: 30px 0px 0px 15px !important;
  /* overflow: hidden; */
  height: 40px;
  background-color: #6a6a6a;
  color: white;
  font-weight: bold;
  font-size: var(--font-big);
}
.run-details {
  width: 100%;
  height: 60px;
  margin: 0px 10px;
}
span.text-description {
  min-height: 30px;
  width: 100%;
  margin-bottom: 1px;
  background-color: #fafafa;
}
span.text-description > bold {
  height: 30px;
  width: 150px;
  color: black;
  background: #e7e7e7;
  margin-right: 20px;
}
.product-content.selector {
  min-height: 400px;
}
.product-content {
  min-height: 750px;
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: space-between; */
  margin-bottom: 50px;
}
.profile-view {
  background-color: white;
  border-radius: 50%;
  position: relative;
}
.profile-view > img {
  height: calc(var(--header-height) - 10px);
  width: calc(var(--header-height) - 10px);
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid white;
}
.profile-view > .profile-detail {
  /* display: none; */
  position: absolute;
  right: 0;
  width: 150px;
  height: 70px;
  background: white;
  padding: 5px;
  border-radius: 5px;
  /* transition: 500ms; */
}

.error-label-message {
  width: 100%;
  padding: 10px 5px;
  background-color: white;
  text-align: center;
  border-bottom: 2px solid red;
}
.popup-alert.grey-bg {
  background-color: #525659 !important;
}
.label-info-edit.active {
  right: -340px;
  /* transform: rotate(0deg);
  transform-origin: 0 0; */
  opacity: 1;

  transition: 250ms;
  background-color: white;
}
.label-info-edit {
  /* transition: 1s ease-in-out 500ms; */
  /* transform: rotate(90deg); */
  /* transform-origin: 0 0; */
  position: absolute;
  right: 0px;
  top: 0;
  min-height: 100px;
  min-width: 300px;
  opacity: 0;
  background: none;
  z-index: 5;
  border-radius: 0 8px 8px 8px !important;
}

.label-info-edit-body > span {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  padding: 10px 17px;
  background-color: #71777b;
  color: white;
  font-weight: bold;
  border-radius: 0 8px;
}
.label-info-edit-body {
  margin-top: 50px;
  float: right;
  padding: 10px 20px 10px 30px;
  width: 350px;
}
.popup-alert.large {
  min-height: 300px;
}
.popup-alert {
  min-height: 100px;
  min-width: 400px;

  background-color: white;
  z-index: 99;
  margin-top: 50px;
}

.size-content > .head {
  width: 100%;
  display: flex;
  justify-content: space-around;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}
.size-content > .contents > span > span.amount {
  color: black;
  font-weight: normal;
  float: right;
}
.size-content > .contents {
  background-color: #eaeaea;
  max-height: 200px;
  overflow-y: scroll;
}
.size-content > .contents > span {
  color: var(--rf-brand-lite);
  font-weight: bold;
  width: 100%;
  font-size: var(--font-medium);
  border-bottom: 1px solid white;
  margin: 2px 0;
}
.size-content > .head > span {
  padding: 4px 10px;
  font-size: var(--font-medium);
  cursor: pointer;
  text-align: center;
  color: #6a6a6a;
}
.size-content > .head > span.active {
  background-color: #888787;
  color: white;
}
.size-content > .head > span.active > span {
  font-size: var(--font-big);
  font-weight: bold;
  background-color: white;
  color: var(--rf-brand-lite);
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  padding: 8px 15px;
  margin-right: -15px;
  margin-left: 10px;
  /* border-radius: 10px 0; */
}
.related-list {
  border-radius: 1px solid black !important;
  border-bottom: 1px solid var(--rf-brand-lite);
  padding: 2px 5px;
}

.related-list:hover {
  background-color: #f8e6be !important;
}
.loading-spin {
  border-radius: 50%;
  border-bottom: 2px solid var(--rf-brand-lite);
  animation: loading 500ms linear infinite;
}
.loading-spin.white {
  border-bottom: 2px solid white !important;
}
.loading-spin.red {
  border-bottom: 2px solid rgb(210, 116, 116) !important;
}
.loading-spin.small {
  width: 15px;
  height: 15px;
}
.loading-spin.large {
  width: 50px;
  height: 50px;
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.collapsable-hor {
  width: 400px;
  margin-left: 20px;
}
.collapsable-hor > span {
  height: 30px;
  width: auto;
  margin-bottom: 10px;
  padding: 10px 0px;
  /* color: white; */
  font-size: var(--font-medium);
}
.work-order-tooltip {
  position: absolute;
  left: 50px;
  min-height: 30px;
  min-width: 200px;
  background-color: white;
  border-radius: 5px;
  z-index: 99;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.2);
}
.work-order-tooltip > .body > .title {
  background-color: white;
  color: #c48650;
  height: auto !important;
  /* box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.2); */
  margin-bottom: 10px;
  text-align: center;
  padding: 5px !important;
  border-radius: 0 5px 0 0;
}
.work-order-tooltip > .body > span {
  padding: 3px 30px !important;
  height: auto;
  display: block;
  /* width: 100% !important; */
}
.work-order-tooltip > .body {
  border-radius: 5px;
  z-index: 99;
  position: absolute;
  width: 100%;
  min-height: 30px;
  background-color: white;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
}
.work-order-tooltip > .edge {
  background-color: var(--rf-brand-lite);
  position: absolute;
  top: 5px;
  left: -9.5px;
  height: 20px;
  width: 20px;
  transform: rotate(45deg);
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
}
.list-num {
  position: absolute;
  left: -30px;
}
.option-list {
  width: 100%;
  display: flex;
  /* border: 1px solid grey; */
  flex-direction: column;
  margin-top: -10px;
}
.option-list > div {
  font-weight: bold;
  text-align: center;
  /* background-color: #6a6a6a; */
  /* color: white; */
  padding: 4px;
  font-size: var(--font-medium);
}
.option-list > span {
  padding: 2px 10px;
  font-size: 12px;
  width: 100%;
  cursor: pointer;
  /* background-color: white; */
  margin-bottom: 1px;
}
.option-list > span:hover {
  /* background-color: #c0c0c0; */
  /* color: white; */
}
.border-left-1 {
  border-left: 1px solid grey;
}

/* library css modifications */
.react-datetime-picker__wrapper {
  border: none !important;
}
.react-datetime-picker__calendar-button {
  width: 40px !important;
}
.react-calendar__navigation {
  background-color: var(--rf-brand-lite) !important;
}
.react-calendar__navigation > button {
  color: white !important;
  font-weight: bold;
}
.react-calendar__navigation > button:hover {
  background-color: #d9b465 !important;
}

.profit-modal-open > .profit-display {
  /* width: 30%; */
  border-radius: 10px;
  overflow: hidden;
}
.profit-modal-open {
  transition: 500ms;
  position: absolute;
  width: 100%;
  height: 800px;
  left: 0px;
  top: -80px;
  z-index: 100;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.3);
  background: white;
  padding: 20px 10px;
}

.profit-display {
  height: 100px;
  width: 100%;
}
.profit-display > div {
  width: 50%;
}
.profit-display > div > span.amount {
  /* display: block; */
  font-size: 30px !important;
  font-weight: bold;
  height: 70px;
  width: 100%;
}
.profit-display > div > span.text {
  /* display: block; */
  font-weight: bold;
  height: 30px;
  width: 100%;
  font-size: 11px;
}
.count-display {
  width: 100%;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.card-number {
  width: auto;
  height: 100px;
  margin: 0px 3px !important;
}
.card-number.small {
  height: 75px;
}
.card-number.small > span.count {
  height: 60px;
  font-size: 25px;
}
.card-number > span.count > .side {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 15px;
  width: 30px;
  height: 55px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-number > span.count.large {
  font-size: 60px;
}
.card-number > span.count {
  color: var(--rf-brand-lite);
  height: 80px;
  font-size: 40px;
}
.card-number.small > .text {
  height: 15px;
  font-size: 10px;
}
.card-number > .text {
  color: white;
  background-color: #b79800;
  height: 20px;
  font-size: 11px;
}
.progress-div {
  width: 100%;
  height: 25px;
  background: #eaeaea !important;
  margin-top: 2px;
}
.progress-div > div.bar {
  display: flex;
  justify-content: space-between;
  height: 5px;
  background-color: var(--rf-brand-lite);
}
.progress-div > div.bar > span {
  height: 25px;
  color: #48484a;
  font-weight: bold;
  font-size: 11px;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3px;
}

.notification-board > .head {
  width: 100%;
  background: #848484;
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 0px;
  text-align: center;
}

.notif-bar {
  height: 40px;
  background: #e5e5e5;
  margin-top: 1px;
}
.notif-icon.red > svg {
  /* color: #e77171; */
}
.notif-icon {
  background-color: #aaa9a9;
  display: flex;
  width: 40px;
  height: 40px;
}
.notif-text {
  padding: 0px 15px;
  font-size: 11px;
}
.title-separator.xsmall {
  height: 10px;
  margin-bottom: 5px;
}
.title-separator.xsmall > .text {
  font-size: 8px;
}

.title-separator.push-top {
  margin-top: 30px;
}
.title-separator {
  width: 100%;
  height: 20px;
  margin-bottom: 10px;
}
.title-separator > .line {
  border-top: 1px solid #6a6a6a;
  height: 3px;
  width: 100%;
}
.title-separator > .text {
  position: absolute;
  left: 20px;
  background: white;
  width: auto !important;
  padding: 0px 10px;
  font-weight: bold;
  font-size: 11px;
}
.detailed-progress-bar {
  display: flex;
  align-items: end;
  width: 100%;
  background-color: white;
  height: 25px;
  margin-top: 20px;
}
.detailed-progress-bar > div > .bar.low {
  background: #d17272;
}
.detailed-progress-bar > div > .bar.mid {
  background: #d1cb72;
}
.detailed-progress-bar > div > .bar.high {
  background: #7dd172;
}
.detailed-progress-bar > div > .bar {
  height: 5px;
  /* background: #d19e72; */
}
.detailed-progress-bar > div > .bar > .counter {
  /* display: block; */
  width: 35px;
  /* background-color: #97704d; */
  color: black;
  border-radius: 0px 5px 5px 0px;
  height: 25px;
  font-size: 11px;
  position: absolute;
  right: 5px;
  top: -20px;
}

.bar-count {
  width: 40%;
  background-color: #f4f2f2;
  /* padding-left: 10px; */
  height: 25px !important;
  border-right: 1px solid gray;
}
.bar-count > span {
  padding-left: 10px;
}
.bar-count > span > .number {
  font-size: 22px;
  font-weight: bold;
  /* position: absolute;
  left: 0px;
  bottom: 10px; */
  margin-right: 5px;
  color: #97704d;
}
.bar-count > span > .txt {
  font-size: 11px;
  color: var(--rf-brand-lite);
}
button.print-btns.active {
  background-color: #f1d9a6;
  color: #fff;
}
button.print-btns {
  font-size: 12px;
  /* font-weight: bold; */
  margin-bottom: -5px;
  margin-left: 5px;
  /* border: 0px; */
  border: 1px solid #c6c6c6;
  height: 30px;
  min-width: 150px;
  padding: 0px 30px;
  color: var(--rf-brand-lite);
  border-radius: 3px;
}
.printer-panel > input {
  padding: 5px 0px;
  /* display: block; */
  width: 50px;
  height: 20px;
  text-align: center;
  font-size: 11px !important;
}
.printer-panel {
  background: white;
  width: 100%;
  height: 50px;
  z-index: 100;
  /* border-radius: 0px 0px 25px 25px; */
}

.div-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 5px;
  background: #6a6a6a;
  color: white;
  font-size: var(--font-small);
}
.dashboard-btn {
  position: absolute;
  left: 300px;
  width: 150px;
  background: var(--rf-brand-lite);
  padding: 7px 10px;
  border-radius: 5px;
  font-weight: bold;
}
.counter-div {
  width: 20px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background: #009688;
  color: white;
  font-weight: bold;
  font-size: 12px;
  margin-left: 10px;
  position: absolute;
  right: -10%;
}
.calendar-page-picker {
  /* height: 30px; */
  background-color: white;
  width: 100% !important;
  margin-bottom: 5px;
  /* overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap; */
  padding: 0px 25px;
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.25);
}
.calendar-page-picker > span.btns {
  width: 20px !important;
  height: 25px;
  background-color: white;
  padding: 0px 3px;
}
.calendar-page-picker > span:hover {
  color: var(--rf-brand-lite) !important;
}
.calendar-page-picker > span {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 5px 23px; */
  font-weight: bold;
  height: 25px;
  cursor: pointer;
  width: 103px;
  font-size: 11px;
  /* background-color: white; */
  /* box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.25); */
}
.calendar-page-picker > span.selected {
  color: var(--rf-brand-lite) !important;
  font-size: 12px;
  margin-top: -10px;
  background-color: white;
  border-bottom: 2px solid var(--rf-brand-lite);
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.25);
}

.date-picker-slider {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.date-slider {
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.date-slider-item {
  min-width: 120px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  margin-right: 8px;
}

.date-slider-item.selected {
  background-color: #007bff;
  color: #fff;
}

.nav-buttons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
}

.nav-buttons button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 4px;
}

.nav-buttons button:hover {
  background-color: #0056b3;
}

.ver-nav {
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.ver-nav > span {
  padding: 5px 10px;
  cursor: pointer;
  margin-bottom: 4px;
  box-shadow: 0px 3px 8px rgba(142, 139, 139, 0.1);
}
.ver-nav > span:hover {
  color: #f6efdf;
}
.ver-nav > span.selected {
  color: #f3ca71;
  font-weight: bold;
}
.wage-input {
  height: 20px;
  border: 1px solid rgb(189, 189, 189);
  width: 80px;
  /* background-color: red; */
}

.order-titles {
  width: 100%;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: bold;
  color: #009688;
  box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.25);
  background: white;
}
.pulsing-div {
  height: 1000px;
  width: 1000px;
  background: radial-gradient(
    circle,
    rgba(245, 245, 245, 1) 0%,
    rgba(190, 189, 189, 1) 2%,
    rgba(245, 245, 245, 1) 3%
  );
}
.pulsing-div.wide {
  background: radial-gradient(
    circle,
    rgba(245, 245, 245, 1) 0%,
    rgba(190, 189, 189, 1) 50%,
    rgba(245, 245, 245, 1) 90%
  );
}
.page-date-display {
  height: 35px;
  /* width: 80%; */
  background-color: white;
  padding: 0 60px;
  /* position: absolute;
  top: 0;
  left: 0;
  z-index: 99; */
  margin-bottom: 5px;
  overflow: hidden;
  color: var(--rf-brand-lite);
}

.side.card-side-wedge {
  transform: rotate(45deg);
  position: absolute;
  left: -20px;
  top: 0;
  width: 35px;
  height: 35px;
  background-color: var(--rf-brand-lite);
}

.short-price > span {
  padding: 5px 10px !important;
  width: 100%;
  /* font-weight: bold; */
  text-align: left;
}
.short-price {
  padding-left: 10px;
  background-color: #f1e9d9;
  color: black;
  /* border-radius: 6px; */
  border: 1px dashed rgb(168, 168, 168);
  /* height: 40px; */
}
.border-right {
  border-right: 1px solid rgb(168, 168, 168);
  padding-left: 10px;
}

.removable-tag-list.cc-edit:hover {
  background: #f4f4f4;
}
.removable-tag-list.cc-edit {
  background: #e0dfdf;
  cursor: pointer;
}
.removable-tag-list {
  /* background: #66B755; */
  /* color: white; */
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 11px;
  /* width: 100px; */
  margin: 4px 2px;
  /* position: absolute; */
}

.block {
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 0px 18px !important;
}
header.golden-card {
  background: #f5f5f5;
  color: var(--rf-brand-lite);
  padding: 4px 0px;
}
.form-button {
  width: 30px;
  height: 30px;
  background-color: #d16b6b;
  color: white;
  cursor: pointer;
  padding: 5px;
}
.report-container > .report-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.report-container > .report-body {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  margin: 10px 0px 0px 40px;
  border-left: 2px solid #009688;
}
.print-label > p.label-row {
  position: absolute;
  width: 100%;
  left: 0;
  /* border: 1px solid grey; */
}
.print-label.printed {
  background-color: #ceffbd;
}
.print-label-img {
  width: 384px;
  height: 192px;
  border-radius: 8px;
  margin-top: 10px;
}
.print-label-img > .text {
  position: absolute;
  color: #fe803d;
}
.print-label {
  position: relative;
  background-color: white;
  border-radius: 4px;
  width: 384px;
  height: 192px;
  /* font-size: 16px; */
  padding: 20px 20px;
  font-family: Arial;
  font-style: italic;
  font-weight: 450;
  overflow: hidden;
  padding: 0px;
}
.overlay-loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 88px;
  height: 10px;
  --_g: no-repeat radial-gradient(farthest-side, #efd6a0 94%, #0000);
  background: var(--_g) 25% 0, var(--_g) 75% 0;
  background-size: 10px 10px;
  /* position: relative; */
  animation: l24-0 0.8s linear infinite;
}
.loader:before {
  content: "";
  position: absolute;
  height: 10px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #efd6a0;
  inset: 0;
  margin: auto;
  animation: l24-1 0.8s cubic-bezier(0.5, 300, 0.5, -300) infinite;
}
@keyframes l24-0 {
  0%,
  24% {
    background-position: 25% 0, 75% 0;
  }
  40% {
    background-position: 25% 0, 85% 0;
  }
  50%,
  72% {
    background-position: 25% 0, 75% 0;
  }
  90% {
    background-position: 15% 0, 75% 0;
  }
  100% {
    background-position: 25% 0, 75% 0;
  }
}
@keyframes l24-1 {
  100% {
    transform: translate(0.1px);
  }
}

.runsheet-card {
  width: 300px;
  min-height: 100px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0px 2px;
}
.runsheet-card > .body {
  padding: 5px;
}
.runsheet-card > .body > span > span {
  text-align: left;
}
.runsheet-card > .head {
  height: 30px;
  width: 100%;
  font-weight: bold;
  line-height: 30px;
  padding-left: 10px;
  text-align: left;
  color: white;
  /* background-color: red; */
}

.row-tag .name {
  font-size: 14px;
  color: white;
  width: 100%;
}
.row-tag:hover {
  z-index: 101 !important;
}
.row-tag {
  transform: rotate(90deg);
  position: absolute;
  height: 30px;
  width: 200px;
  left: 0px;
  top: 0px;
  transform-origin: 0% 0%;
  border-radius: 0px 0px 10px 10px;
}
.date-range-picker {
  margin-bottom: 10px;
  border-radius: 5px;
}
.hor-list-selector > span.active {
  background-color: #efefef;
  color: #b79800;
}
.hor-list-selector > span:hover {
  background-color: #e1e1e1;
  color: #b79800;
}
.hor-list-selector > span {
  font-size: 10px;
  color: white;
  font-weight: bold;
  background-color: #7c7c7c;
  padding: 4px 20px;
  border-right: 1px solid white;
  text-align: center;
  cursor: pointer;
}
.flex-grow {
  flex-grow: 100;
}
.datetime-range-picker {
  /* background-color: red; */
  width: 300px;
  height: 35px;
  margin-left: 10px;
}
.datetime-range-picker > .calenders.active {
  display: flex;
}
.cale-btns {
  margin: 0px 5px;
  cursor: pointer;
}
.printer-dropdown-item:hover {
  background-color: #f5f5f5 !important;
  cursor: pointer;
}

.pick-btn {
  padding: 5px 20px;
}

/* entry animation  */

/* .sqe-3 */

@media {
  :root {
    --translate-offset: -300px;
    --scale-by: 0.9;
  }
}

@keyframes fadeInToLeft {
  0% {
    opacity: 0;
    right: var(--translate-offset);
    transform: scale(var(--scale-by));
  }
  70% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
    opacity: 1;
    right: 0px;
  }
}
@keyframes fadeInToRight {
  from {
    opacity: 0;
    left: var(--translate-offset);
    transform: scale(var(--scale-by));
  }
  70% {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
    opacity: 1;
    left: 0px;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    /* transform: scale(var(--scale-by)); */
  }
  to {
    opacity: 1;
    /* transform: scale(1); */
  }
}

.zoom-in {
  /* animation: zoomIn 1s forwards; */
}

.in-animation-to-left {
  position: relative;
  height: 600px;
  width: 100%;
  /* animation: fadeInToLeft 1s forwards; */
}

.in-animation-to-right {
  position: relative;
  height: 600px;
  width: 100%;
  /* animation: fadeInToRight 1s forwards; */
}
.full-modal {
  width: 100% !important;
  z-index: 10;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 700px;
}
.small-table-row > td,
th {
  padding: 2px 10px !important;
}
.ordered-list-table {
  max-height: 700px;
  overflow-y: scroll;
}

/* For webkit-based browsers */
.thin-red-scrollbar::-webkit-scrollbar {
  width: 4px; /* Width of the scrollbar */
  height: 4px; /* Height of the scrollbar */
}

.thin-red-scrollbar::-webkit-scrollbar-track {
  background: transparent; /* Background of the scrollbar track */
}

.thin-red-scrollbar::-webkit-scrollbar-thumb {
  background-color: #f0d499; /* Color of the scrollbar thumb */
  border-radius: 5px; /* Rounded corners of the scrollbar thumb */
  border: 2px solid transparent; /* Adds space around thumb */
}

/* For Firefox */
.thin-red-scrollbar {
  scrollbar-width: thin; /* Makes the scrollbar thin */
  scrollbar-color: #f0d499 transparent; /* Color of the thumb and track */
}

.small-tag {
  color: white;
  padding: 0px 10px;
  background: #a6a5a5;
  border-radius: 5px;
}
.large-lable {
  padding: 5px 20px;
  border: 1px solid grey;
  font-weight: bold;
}
.header-small {
  background: #eaeaea;
  padding-left: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.border-gold {
  border: 2px solid #b79800;
}
.border-grey {
  border: 1px solid #6a6a6a;
}
.circle {
  border-radius: 50%;
  padding: 2px;
  /* height: 20px !important; */
  aspect-ratio: 1/1;
}
.wedget-header {
  border-radius: 8px 8px 0px 0px;
  font-size: 16px;
  color: white;
  background: #6a6a6a;
  padding: 4px 12px;
}
.progress-fields {
  background-color: #55b79e !important;
  font-weight: normal;
  font-size: 11px;
  /* display: flex; */
  /* align-items: center; */
}
.justify-end {
  display: flex;
  justify-content: end;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.no-shaodw {
  box-shadow: none !important;
}
.light-border {
  border: 1px solid rgb(230, 230, 230) !important;
}

/*
.pop-overlay.left{
  left: 0; 
}
.pop-overlay.right{
  right: 0; 
}
.pop-overlay{
  position:absolute; 
  top: 0; 
  height:85vh;
  width: 40%;
  background: white;
  z-index:100;
  padding: 10px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
}
*/`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;IAC9B,uDAAuD;IACvD,SAAS,EAAE,mBAAmB;EAChC;EACA;IACE,wBAAwB;IACxB,SAAS,EAAE,mBAAmB;EAChC;EACA;IACE,SAAS;IACT,UAAU;IACV,oDAAoD;IACpD,sDAAsD;EACxD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;;;;;;;CAOC;AACD;EACE,8DAA8D;;EAE9D;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,yDAAyD;EACzD;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,sCAAsC;EACtC,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,yCAAyC;EACzC,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kDAAkD;AACpD;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;sBACoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EAIZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;;EAEE,wBAAwB;EACxB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA,kCAAkC;AAClC;;EAEE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AACA,iCAAiC;AACjC;EACE,qBAAqB;AACvB;AACA;;GAEG;AACH;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,2CAA2C;EAC3C,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,6CAA6C;EAC7C,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,4DAA4D;EAC5D,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;EAGE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,sDAAsD;EACtD,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,4DAA4D;AAC9D;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;EAC7D,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA;EACE,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,uDAAuD;EACvD,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV;0DACwD;AAC1D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV;4DAC0D;AAC5D;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,QAAQ;EACR,iBAAiB;EACjB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb;0BACwB;EACxB,UAAU;;EAEV,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;;EAEhB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,sDAAsD;AACxD;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB;;iBAEe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB;;wBAEsB;EACtB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,iDAAiD;AACnD;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,aAAa;EACb;;;;;GAKC;AACH;AACA;EACE;;;;;GAKC;AACH;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf;;;gBAGc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,4CAA4C;EAC5C,0BAA0B;EAC1B,wBAAwB;EACxB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gEAAgE;AAClE;AACA;EACE;;IAEE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;;IAEE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;;AAErB,WAAW;;AAEX;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,6BAA6B;IAC7B,iCAAiC;EACnC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,SAAS;EACX;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,UAAU,EAAE,2BAA2B;EACvC,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;EACE,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,kBAAkB,EAAE,2CAA2C;EAC/D,6BAA6B,EAAE,4BAA4B;AAC7D;;AAEA,gBAAgB;AAChB;EACE,qBAAqB,EAAE,6BAA6B;EACpD,oCAAoC,EAAE,iCAAiC;AACzE;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,+CAA+C;AACjD;;AAEA;;;;;;;;;;;;;;;;;CAiBC","sourcesContent":["body > iframe {\n  display: none;\n}\n\n@media print {\n  .no-print,\n  .no-print * {\n    display: none !important;\n  }\n  .rotate-90 {\n    /* transform: rotate(90deg); */\n    /* size: A5 landscape; Set A5 paper in landscape mode */\n    margin: 0; /* Remove margins */\n  }\n  @page {\n    /* size: A5 landscape; */\n    margin: 0; /* Remove margins */\n  }\n  body {\n    margin: 0;\n    padding: 0;\n    /* width: 210mm; A5 width in landscape orientation */\n    /* height: 148mm; A5 height in landscape orientation */\n  }\n}\n\n@media (max-width: 1100px) {\n  :root {\n    --side-slide-width: 97%;\n  }\n}\n@media (min-width: 1100px) {\n  :root {\n    --side-slide-width: 1000px;\n  }\n}\n\n:root {\n  --font-print: 12px;\n}\n.font-print {\n  font-size: var(--font-print);\n}\n/* \nbootstrap responsive break points \nxs - 575px\nsm - 767\nmd - 991\nlg - 1200\n// Large devices (desktops, less than 1200px)\n*/\n@media (max-width: 575.98px) {\n  /* // Extra small devices (portrait phones, less than 576px) */\n\n  :root {\n    --font-xbig: 20px;\n    --font-big: 20px;\n    --font-medium: 10px;\n    --font-small: 20px;\n    --font-xSmall: 20px;\n    --hide-on-sm: none;\n    --header-height: 30px;\n    --side-nav-left: -100%;\n  }\n}\n\n@media (max-width: 767.98px) and (min-width: 575.98px) {\n  /* // Small devices (landscape phones, less than 768px) */\n  :root {\n    --font-xbig: 14px;\n    --font-big: 12px;\n    --font-medium: 11px;\n    --font-small: 8px;\n    --font-xSmall: 6px;\n    --header-height: 30px;\n    --side-nav-left: -100%;\n  }\n}\n\n@media (max-width: 991.98px) and (min-width: 767.98px) {\n  :root {\n    --font-xbig: 20px;\n    --font-big: 20px;\n    --font-medium: 13px;\n    --font-small: 20px;\n    --font-xSmall: 20px;\n    --header-height: 50px;\n    --side-nav-left: -220px;\n  }\n}\n\n@media (min-width: 991.98px) {\n  :root {\n    --font-xbig: 22px;\n    --font-big: 20px;\n    --font-medium: 14px;\n    --font-small: 10px;\n    --font-xSmall: 8px;\n    --hide-on-sm: flex;\n    --header-height: 50px;\n    --side-nav-left: -220px;\n  }\n}\n\n* {\n  transition: 300ms;\n}\n\na {\n  color: var(--rf-brand-lite) !important;\n  text-decoration: none !important;\n}\n\nbody {\n  font-family: Arial, Helvetica, sans-serif;\n  margin: 0;\n  overflow-x: hidden;\n}\n.app-content {\n  position: relative;\n  z-index: 0;\n}\n.page-title {\n  color: white;\n  font-size: var(--font-xbig);\n  font-weight: bold;\n  margin-left: 200px;\n}\n.container {\n  width: 70%;\n  margin-left: 15%;\n  font-family: Arial, Helvetica, sans-serif;\n}\n.message {\n  height: 50px;\n  background-color: #f0f0f0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 3px;\n}\n.message.header {\n  border-radius: 0px;\n  background-color: #c48650;\n  color: black;\n  font-weight: bold;\n  font-size: 16px;\n}\n.text {\n  width: 85%;\n}\n.date {\n  width: 10%;\n  text-align: center;\n}\n\n.header.simple {\n  height: 20px;\n}\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: var(--header-height);\n  background-color: var(--rf-brand-lite);\n  box-shadow: 0px 3px 14px #a6a5a5;\n  z-index: 99;\n}\n.icon-btn {\n  height: 30px;\n}\n.header > .btn-slider {\n  width: 50px;\n  height: 50px;\n  color: white;\n  cursor: pointer;\n}\n.logo.simple {\n  left: -3px;\n  top: -15px;\n  width: 60px;\n  aspect-ratio: 1/1;\n  border-radius: 50%;\n}\n.logo.simple > a > img {\n  width: auto;\n  height: 20px;\n}\n.logo {\n  position: absolute;\n  left: 50px;\n  top: 0px;\n  background-color: white;\n  height: calc(var(--header-height) + 10px);\n  width: 120px;\n  box-shadow: 0px 3px 14px #a6a5a5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.logo > a > img {\n  width: calc(40px + var(--header-height));\n}\nimg.right {\n  position: absolute;\n  width: 13px;\n  right: -14px;\n  bottom: -3px;\n  z-index: 0;\n}\n\n.sideNav {\n  position: fixed;\n  z-index: 0;\n  width: 270px;\n  height: 100vh;\n  background-color: white;\n  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  padding-top: 100px;\n  transition: 400ms;\n  left: 0%;\n  top: 0;\n  z-index: 2;\n}\n.sideNav.noshow {\n  transition: 400ms;\n  left: var(--side-nav-left);\n}\n.sideNav > span.active {\n  background-color: #f8f8f8;\n}\n.sideNav > span {\n  padding-left: 10px;\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #cccccc;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.input-forms.stretch {\n  width: 100% !important;\n}\n.input-forms.date-picker > span.label {\n  width: 15%;\n  font-size: 12px;\n  font-weight: bold;\n}\n.input-forms.flat.height-thin {\n  height: 30px !important;\n}\n.input-forms.flat.height-mid {\n  height: 35px !important;\n  border-radius: 0px !important;\n  background-color: #ffffff !important;\n}\n.input-forms.flat.height-small {\n  border-radius: 0px !important;\n  height: 25px !important;\n  background-color: #ffffff !important;\n}\n.input-forms {\n  width: 300px;\n  height: 35px !important;\n}\n\n.text-input.small {\n  width: 100px;\n}\n.text-input.number {\n  /* height: 35px !important; */\n}\n.date-picker.small-btn.flat {\n  box-shadow: none !important;\n}\n.text-input.date-picker {\n  margin: 0 !important;\n}\n.text-input.flat2 {\n  border-radius: 0px !important;\n  border: 1px solid #eaeaea !important;\n  box-shadow: none !important;\n  margin: 0px !important;\n}\n.flat2-btn {\n  height: 35px;\n}\n.text-input.flat {\n  border-radius: 0px !important;\n  background-color: white !important;\n}\n.text-input {\n  padding: 0px 10px !important;\n  /* background-color:#F5F5F5 !important; */\n  background-color: white !important;\n  /* border-radius: 5px; */\n  border-radius: 0px;\n  border: none;\n  font-size: 12px;\n  margin: 15px 0 10px 0;\n  padding: 0px;\n  /* box-shadow: inset 0px 0px 10px rgba(85, 85, 85, 0.25) */\n  box-shadow: 0px 0px 10px rgba(85, 85, 85, 0.25);\n}\n\n.text-input.light-border {\n  border: 1px solid #d9d8d6;\n  box-shadow: none !important;\n}\n\n.text-input.red-border {\n  border: 1px solid red !important;\n}\n.text-input.flat-white:focus {\n  outline: none !important;\n}\n.text-input.flat2:focus {\n  outline: none !important;\n}\n.text-input.flat-white {\n  background-color: white !important;\n  border-radius: 0px;\n  border-bottom: 1px solid grey;\n  box-shadow: none !important;\n  width: auto;\n  min-width: 100px;\n}\n.search.thin {\n  height: 30px !important;\n  margin: 10px 0px !important;\n}\n.search > input {\n  width: 90%;\n  border-radius: 8px 0 0 8px;\n  height: 30px !important;\n}\n.search > span {\n  background-color: #f2ece0;\n  padding: 0 !important;\n  border: none;\n  width: 10%;\n  min-width: 50px;\n  height: 30px;\n  border-radius: 0 8px 8px 0;\n}\n.search {\n  width: 500px;\n  height: 30px;\n}\n.text-input.search:focus {\n  outline: none !important;\n}\n.text-input:focus {\n  outline: 1px solid var(--rf-brand-lite) !important;\n}\n.text-input.lime-border,\n.text-input.lime-border:focus {\n  outline: 1px solid #55b76a !important;\n}\n.iconed-input {\n  position: relative;\n}\n\n.iconed-input > span {\n  height: 40px;\n  width: 30px;\n  position: absolute;\n  left: calc(100% - 40px);\n  top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.icon.square {\n  aspect-ratio: 1/1;\n}\n.icon.back-red {\n  color: #fff;\n  background: #b75555;\n}\n.icon {\n  color: var(--rf-brand-lite);\n}\n.icon.grey {\n  color: #6a6a6a !important;\n}\n.icon.green {\n  color: #66b755;\n}\n.icon.red {\n  color: #b75555;\n}\n.icon.light-red {\n  color: #b75555;\n}\n\n.dropdown > select {\n  background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+)\n    no-repeat 100% 50%;\n  background-size: 30px 100px;\n  padding-left: 10px;\n  width: 310px;\n\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  outline-width: 0;\n}\n.dropdown > div {\n  width: 20px;\n  background-color: black;\n}\n.fade-text {\n  color: #6a6a6a !important;\n}\n\ntd.checker_img > span {\n  position: absolute;\n  width: 20px !important;\n  right: 15px;\n  bottom: 0;\n}\ntd.checker_img > img {\n  height: 30px !important;\n  width: auto !important;\n}\n\n.table-list.product-list.summary.flat > tr > td:nth-child(1) {\n  width: 10px !important;\n  color: #c48650 !important;\n}\n.table-list.product-list.summary.flat > tr > td:nth-child(2) {\n  width: 90% !important;\n  color: #c48650 !important;\n}\n.table-list.summary.mid-row.flat > tr {\n  height: 35px !important;\n}\n.table-list.summary.small-row.flat > tr {\n  height: 20px !important;\n}\n.table-list.summary.flat.row-xsmall > tr > td:last-child {\n  /* border-bottom: none !important; */\n}\n.table-list.summary.flat.row-xsmall > tr {\n  height: 20px !important;\n}\n.table-list.summary.flat > tr {\n  background-color: white !important;\n}\n.table-list.summary.flat > tr > td:nth-child(1) {\n  width: auto !important;\n  color: #c48650 !important;\n  text-wrap: nowrap;\n}\n.table-list.summary.flat > tr > td,\nth {\n  border: none !important ;\n  border-bottom: 1px solid #ededed !important;\n}\n.table-list.summary {\n  width: 100%;\n  margin-bottom: 20px;\n}\n.table-list.summary > tr > td.action-icon {\n  width: 30px !important;\n}\n.table-list.summary > tr > td:nth-child(n + 3) {\n  width: 100px;\n  font-weight: bold;\n}\n.table-list.summary.pre > tr > td {\n  text-align: center;\n  padding: 0 !important;\n}\n\n.table-list.summary.pre > tr {\n  height: 30px !important;\n}\n.table-list.pre > tr > td:nth-child(1) {\n  width: 40px !important;\n}\n.table-list.summary.pre > tr > td:nth-child(4) {\n  width: auto !important;\n  font-size: 10px !important;\n}\n.table-list.summary.pre > tr > td:nth-child(3) {\n  width: auto !important;\n  font-size: 10px !important;\n}\n.table-list.summary.pre > tr > td:nth-child(n + 4) {\n  /* border: none !important; */\n  width: auto;\n}\n.table-list.summary > tr > td:nth-child(n + 2) {\n  border-left: 2px solid #fff;\n}\n.table-list.summary > tr > td:nth-child(1) {\n  font-weight: bold;\n  width: 30%;\n}\n.table-list.summary > tr > td {\n  text-align: left;\n  padding-left: 10px;\n}\n.table-list.summary > thead > tr,\n.table-list.summary > tr {\n  height: 40px !important;\n}\n.table-list.summary > tr:nth-child(odd) {\n  background-color: #ebebeb;\n}\n.table-list {\n  background-color: rgba(217, 217, 217, 0.1);\n  width: 1800px;\n  font-size: 12px;\n  border-spacing: 0px 20px !important;\n  border-collapse: collapse;\n  position: relative;\n}\n\n.table-list > .head {\n  background-color: #eaeaea;\n  height: 40px;\n}\ntr.bt_table.printing > th {\n  background-color: #ababab;\n}\ntr.bt_table > th {\n  margin-bottom: none !important;\n  text-align: left !important;\n  background-color: #6a6a6a;\n  color: white;\n}\nth {\n  margin-bottom: 10px !important;\n  text-align: center !important;\n}\ntd {\n  /* text-align: center; */\n}\n.light-card {\n  /* background-color: #fafafa; */\n  border-radius: 8px;\n}\ntbody.auto > tr > td {\n  width: auto !important;\n}\n/* tbody > tr > td:nth-child(3)  */\ntbody.print-wo > tr > td:nth-child(1),\ntbody.print-wo > tr > td:nth-child(3) {\n  font-weight: bold;\n  width: 20% !important;\n}\n\ntbody.print-wo.plain > tr > td:nth-child(1),\ntbody > tr > td:nth-child(3) {\n  font-weight: normal;\n  width: auto !important;\n}\n/* tbody > tr > td:nth-child(4) */\ntbody.print-wo > tr > td:nth-child(2) {\n  width: 30% !important;\n}\n/* tbody > tr > td:nth-child(1), tbody > tr > td:nth-child(3){\n  font-weight: bold;\n} */\n.no-wrap {\n  text-wrap: nowrap;\n}\n.table-list > .data {\n  height: 45px;\n  background-color: white;\n  margin-bottom: 2px !important;\n  box-shadow: 0px 2px 10px #eaeaea;\n}\n.table-list > .data:hover {\n  box-shadow: 0px 2px 10px #c4c4c4;\n  z-index: 4;\n}\n.row-separator {\n  height: 35px;\n  color: #6a6a6a;\n  font-size: 10px;\n}\n\n.iconed-button.small {\n  width: 80px;\n  height: 25px;\n  font-size: 10px;\n}\n\n.iconed-button {\n  background-color: #eaeaea;\n  border: none;\n  border-radius: 8px;\n}\n.iconed-button.small > span.text {\n  font-weight: bold;\n}\n\n.iconed-button.small > div {\n  width: 30px;\n}\n\n.iconed-button.small > span.text {\n  width: 50px;\n}\n\n.time-date {\n  width: 160px;\n  height: 25px;\n  font-size: 11px;\n  font-weight: bold;\n  background-color: red;\n  display: flex;\n  justify-content: center;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);\n  z-index: 9;\n}\n.time-date > div {\n  padding-left: 5px;\n}\n.time-date > .time {\n  background-color: var(--rf-brand-lite);\n  color: white;\n  width: 40%;\n}\n.time-date > .date {\n  background-color: white;\n  color: var(--rf-brand-lite);\n  width: 60%;\n}\n.selectable-card.selected {\n  background-color: #ecd39c;\n  color: white;\n  transition: 500ms;\n}\n.selectable-card.simple {\n  height: 40px !important;\n  padding: 10px;\n  font-size: 12px;\n  font-weight: bold;\n}\n.selectable-card > .code,\n.selectable-card.detailed > .code {\n  width: 100px;\n  /* background-color: #6a6a6a; */\n  background-color: var(--rf-brand-lite);\n  color: white;\n  font-weight: bold;\n  font-size: 12px !important;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.selectable-card.detailed > .flowers {\n  position: absolute;\n  bottom: 0;\n  right: 30px;\n}\n.selectable-card.detailed {\n  height: 100px;\n  margin: 8px 0;\n}\n.selectable-card {\n  cursor: pointer;\n  transition: 500ms;\n  box-shadow: 0px 2px 6px rgba(117, 117, 117, 0.25);\n  width: 100%;\n  height: 95px;\n  position: relative;\n  margin: 2px 0 3px 0;\n}\n.selectable-card > img {\n  transition: 500ms;\n  left: -100px;\n  /* opacity: 0; */\n}\n.selectable-card.selected > img {\n  transition: 500ms;\n  left: 40px;\n}\n.selectable-card > .product-img.list {\n  left: 0;\n  height: 95px;\n}\n.selectable-card > .product-img {\n  transition: 500ms;\n  height: 55px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: absolute;\n  left: 25px;\n}\n.selectable-card.selected > span {\n  opacity: 1;\n  transition: 500ms;\n  margin-left: 10px;\n}\n.selectable-card > span {\n  opacity: 0;\n  transition: 500ms;\n}\n.selectable-card > .icon {\n  transition: 500ms;\n  opacity: 0;\n}\n.selectable-card > .product-img.icon {\n  opacity: 1;\n  left: 10px;\n}\n.selectable-card.simple > .text {\n  /* width: auto; */\n  position: relative !important;\n}\n.selectable-card > .text {\n  position: absolute;\n  right: 0px;\n  text-align: center;\n  font-weight: bold;\n  font-size: 12px;\n  width: 80%;\n}\n.map-marker {\n  position: relative;\n  width: 200px;\n  height: 80px;\n  border: 5px solid var(--rf-brand-lite);\n  border-radius: 10px;\n  box-shadow: 2px 8px 12px rgba(0, 0, 0, 0.2);\n}\n.map-marker > .time {\n  position: relative;\n  z-index: 5;\n  font-size: 12px;\n  font-weight: bold;\n}\n.map-marker > .items {\n  background-color: var(--rf-brand-lite);\n  height: 35px;\n  margin: 0;\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n.map-marker > .edge {\n  position: absolute;\n  left: calc(50% - 21px);\n  bottom: -21px;\n  border-bottom: 5px solid var(--rf-brand-lite);\n  border-right: 5px solid var(--rf-brand-lite);\n  width: 30px;\n  height: 30px;\n  rotate: 45deg;\n}\n.map-marker > .edge > div {\n  width: 30px;\n  height: 30px;\n  background-color: white;\n}\n\n.button.tile > span.icon {\n  background-color: #55b89d !important;\n}\n.button.tile > p,\n.button.green > p {\n  color: #fff !important;\n}\n.button.green > span.icon {\n  background-color: #66bb6a !important;\n}\n.button.green.form,\n.button.tile.form {\n  /* box-shadow: 0px 0px 8px rgba(183, 233, 186) !important; */\n  background-color: #b7e9ba;\n}\n.button.cancel {\n  /* background-color: #FBE7E7; */\n  color: rgb(255, 123, 123) !important;\n}\n.button {\n  position: relative;\n  background-color: #eaeaea;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);\n}\n.button:hover {\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);\n}\n.button > p {\n  /* width: 100%; */\n  font-size: var(--font-small);\n  font-weight: bold;\n}\n.button > .icon {\n  /* position: absolute; */\n  height: 80px;\n  width: 5%;\n  /* min-width: 30px; */\n}\n\n.button.form.thin > p,\n.button.form.thin,\n.button.form.thin > .icon {\n  height: 25px !important;\n}\n.button.form.thin > .icon {\n  background-color: #6a6a6a;\n}\n\n.button.form {\n  height: 30px;\n  margin: 10px 0 10px 0;\n  box-shadow: none !important;\n}\n.button.form > p {\n  padding: 3px 10px;\n  color: #6a6a6a;\n  height: 30px;\n}\n.button > .icon.right {\n  right: 0 !important;\n}\n.button > .icon.left {\n  left: 0 !important;\n}\n.button.form > .icon {\n  /* position: absolute; */\n  height: 30px;\n  width: 15%;\n  min-width: 30px;\n  padding: 0 10px 0 10px;\n  background-color: #cbcbcb;\n}\n.button.large > p {\n  /* height: 80px; */\n}\n.button.large {\n  width: 300px;\n  height: 80px;\n  border-radius: 10px;\n}\n.button.mid {\n  width: 175px;\n  height: 36px;\n  border-radius: 10px;\n}\n.button.disabled.light {\n  color: #a2a2a2 !important;\n  background-color: #eaeaea !important;\n}\n.button.disabled {\n  background-color: #c0c0c0 !important;\n  cursor: not-allowed;\n}\n.button.flat.form {\n  height: 35px;\n}\n.button.flat.thin-flat.green {\n  background-color: #55b76d;\n  color: white;\n}\n.button.flat.thin-flat.warnning-btn {\n  background-color: rgb(255, 210, 210);\n  color: #b75555;\n}\n.button.flat.thin-flat {\n  height: 30px;\n}\n\n.button.flat {\n  box-shadow: none !important;\n  border-radius: none !important;\n  height: 50px;\n  color: rgb(106, 105, 105);\n}\n.order-type {\n  display: flex;\n  justify-content: space-around;\n}\n.login-form {\n  width: 310px;\n  height: 100vh;\n  /* background-color: grey; */\n  padding-top: 100px;\n}\n.login-form > img {\n  margin-bottom: 100px;\n  width: 260px;\n}\n.labeled-checkbox {\n  height: 30px;\n  font-weight: bold;\n  font-size: 12px;\n}\n.labeled-checkbox.mid > input {\n  width: 15px;\n}\n.labeled-checkbox.large > input {\n  width: 15px;\n}\n.labeled-checkbox > input {\n  border: none !important;\n  margin-right: 10px;\n  aspect-ratio: 1/1;\n  cursor: pointer;\n}\n.login-form > div {\n  font-size: 12px;\n  color: #a89d9d;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n.order-type-select > h3 {\n  margin-bottom: 100px;\n}\n.order-type-select {\n  width: 900px;\n  height: 100vh;\n  padding-top: 100px;\n}\n.data-input {\n  margin-top: 60px;\n  width: 93%;\n}\n\n.data-input > .datas {\n  width: 95%;\n}\n.summary > .datas {\n  width: 100%;\n  padding: 10px 20px 0 20px;\n}\n.data-row {\n  /* background-color: rgb(190, 189, 189); */\n  min-height: 200px;\n  /* width: 300px; */\n}\n.actions > button > * {\n  height: 34px !important;\n}\n.actions > button {\n  width: 200px;\n  height: 36px !important;\n}\n.actions {\n  margin-top: 200px !important;\n  width: 80%;\n}\n.select-options {\n  position: fixed;\n  top: 65px;\n  left: 80px;\n  width: 95%;\n  min-height: calc(100vh - 220px);\n  z-index: 19;\n  background-color: white;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);\n}\n.select-options > .title > h4 {\n  height: 50px;\n  color: white;\n  font-weight: bold;\n}\n.select-options > .title {\n  padding: 0 -5px 0 -5px !important;\n  background-color: #6a6a6a;\n  height: 50px;\n}\n.title {\n  color: white;\n  font-weight: bold;\n  padding: 0px !important;\n  background-color: var(--rf-brand-lite);\n  height: 80px;\n}\n.title.thin {\n  background-color: #6a6a6a;\n  height: 40px;\n}\n.border-rad-top-LR {\n  border-radius: 10px 10px 0 0 !important;\n  overflow: hidden;\n}\n.select-options > div > .search {\n  margin: 10px 0 30px 0;\n}\n.price-tag {\n  background-color: #fff3da;\n  width: auto;\n  height: auto;\n  border-radius: 10px;\n  padding: 5px 0px;\n}\n.price-tag > div > .msg {\n  width: 40%;\n  height: auto;\n  font-size: 12px;\n  text-align: left;\n  padding-left: 12px;\n}\n.price-tag > div > .pricetot {\n  font-size: var(--font-xbig) !important;\n  font-weight: bold;\n}\n\n.price-tag > div > .price {\n  font-size: var(--font-big);\n  height: auto;\n  width: 60%;\n  text-align: right;\n  padding-right: 12px;\n}\n\n.related-results.hover {\n  position: absolute;\n}\n.related-results {\n  position: relative;\n  min-height: 10px;\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 15px;\n  margin-top: -12px;\n  z-index: 5;\n  padding: 15px 0 20px 0;\n  background-color: #efefef;\n  /* background-color: #a6a5a5; */\n}\n.search-result-row:hover {\n  background: #f3f3f3;\n}\n.search-result-row {\n  font-size: 13px;\n  background-color: white;\n  margin: 0px 0px 3px 0px !important;\n  /* padding-bottom: ; */\n}\nlabel.input.focused {\n  opacity: 1;\n  top: -4px;\n  transition: 400ms;\n}\nlabel.input {\n  transition: 400ms;\n  font-size: 12px;\n  opacity: 0;\n  font-weight: bold;\n  color: #c48650;\n  position: absolute;\n  top: 0px;\n  left: 5px;\n}\n.icon-link {\n  position: absolute;\n  right: 0;\n  height: 42px;\n  background-color: #856a52;\n  width: 23px !important;\n  padding: 0 !important;\n}\n\ndiv.type {\n  height: 20px;\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  border-radius: 5px;\n  padding: 4px 10px;\n  background-color: #c48650;\n  color: white;\n}\n.xlight-lime-bg {\n  background-color: #b4f8c0 !important;\n}\n.xlight-gold-bg {\n  background-color: #f6ecd9 !important;\n}\n.work-order-list {\n  background-color: #fafafa;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1) !important;\n  min-height: calc(750px);\n  padding-bottom: 100px;\n}\n.table-head {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  background-color: #6a6a6a;\n  box-shadow: 0px 3px 8px rgba(150, 146, 146, 0.87) !important;\n}\n.table-head > span {\n  padding: 3px 0px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto !important;\n  /* min-height: 40px; */\n  font-weight: bold;\n  color: white;\n  width: 9%;\n}\n.content-row:hover {\n  transition: 400ms;\n  /* background: #aef68d; */\n  background: #fbf8f0;\n  cursor: pointer;\n  box-shadow: 0px 4px 15px rgba(157, 157, 157, 0.55) !important;\n  /* background-color: #FEF5E1; */\n}\n.parent-child-detail {\n  background: #f5f2f2 !important;\n  border-left: 2px solid var(--rf-brand-lite);\n}\n.product-card > .products {\n  display: flex;\n  align-items: center;\n}\n.product-card > .txt {\n  background-color: #eaeaea;\n  color: #6a6a6a;\n  padding: 2px 5px;\n}\n.product-card {\n  min-width: 20% !important;\n  display: block;\n  text-align: right;\n  background-color: #fbf8f0;\n  border-top: 2px solid #f9dfa4;\n  padding: 0px 10px 0px 0px;\n}\n.content-row {\n  margin: 7px 0px;\n}\n.content-row > div.lower {\n  width: 100%;\n  justify-content: end;\n}\n.product-tag.selected {\n  background-color: #55b761;\n}\n.product-tag.extras {\n  background: white;\n  border-radius: 0;\n}\n.product-tag {\n  padding: 1px 8px;\n  background-color: #c7b691;\n  color: white;\n  border-radius: 8px;\n  margin: 0px 3px;\n  white-space: nowrap;\n  font-weight: bold;\n}\n.content-row {\n  box-shadow: 0px 3px 10px rgba(157, 157, 157, 0.25) !important;\n  background-color: white;\n}\n\n.table-row-content {\n  transition: 00ms;\n  width: calc(100% - 0px);\n  cursor: pointer;\n  margin-top: 2px;\n}\n.table-row-content > span {\n  /* padding: 8px 40px; */\n  height: auto !important;\n  min-height: 30px;\n  display: flex;\n  width: 9%;\n  justify-content: center;\n  align-items: center;\n}\n.content-row.active,\n.content-row.compact.active {\n  border-left: 2px solid #f9dfa4 !important;\n  margin-left: 20px !important;\n}\n.table-row-content.compact {\n  height: 40px;\n  padding: 0px 10px;\n}\n.order-side-slide.searchWO > .title {\n  background-color: white;\n  border-bottom: 1px solid gray;\n}\n.order-side-slide.searchWO {\n  top: 10px;\n  width: 600px;\n  min-height: calc(100vh - 100px);\n}\n.order-side-slide.product {\n  width: 600px;\n  min-height: calc(100vh - 100px);\n}\n.order-side-slide.flowers {\n  width: 700px;\n}\n.order-side-slide {\n  width: var(--side-slide-width);\n  position: absolute;\n  right: -100%;\n  top: 60px;\n  transition: 300ms;\n  background-color: white;\n  z-index: 50;\n  min-height: calc(100vh - 60px);\n  display: none;\n  padding-bottom: 50px;\n}\n.order-side-slide.shadow-none.active {\n  box-shadow: none !important;\n}\n.order-side-slide.active {\n  display: block;\n  transition: 300ms;\n  right: 10px !important;\n  /* box-shadow: -850px 0px 100px rgba(0, 0, 0, 0.2) !important; */\n}\n\n.collapsing.card-body {\n  opacity: 0;\n  transition: 1s;\n  height: 0px !important;\n  width: 100%;\n  display: none;\n}\n.active.collapsing.card-body {\n  /* min-height: 150px !important; */\n  height: auto !important;\n  transition: 1s;\n  opacity: 1;\n  display: block;\n}\n.collapsing > h5 {\n  height: 30px !important;\n  cursor: pointer;\n  font-weight: bold;\n}\n.collapsing > h5:hover {\n  box-shadow: 0px 4px 15px rgba(157, 157, 157, 0.35) !important;\n  background-color: #fef5e1;\n}\n.collapsing {\n  border-radius: 0px !important;\n  border: none !important;\n  margin-top: 2px !important;\n  padding: 5px 0px 0px 0px !important;\n}\n.user-bar {\n  cursor: none;\n}\n.user-bar:hover {\n  background-color: white !important;\n  box-shadow: 0px 3px 8px rgba(142, 139, 139, 0.1) !important;\n}\n\n.toggle-radio {\n  width: auto;\n  border-radius: 4px;\n  overflow: hidden;\n  height: 25px;\n}\n.toggle-radio > a.active {\n  background-color: #6a6a6a;\n  color: white !important;\n}\n.toggle-radio > a {\n  color: #6a6a6a !important;\n  height: 25px;\n  width: auto;\n  padding: 3px 10px;\n  font-weight: bold;\n  cursor: pointer;\n  text-decoration: none;\n}\n.product-page {\n  width: 90%;\n  border: 1px solid #d8d8d8;\n  border-radius: 20px;\n  margin-top: 70px;\n  min-height: calc(100vh - 80px);\n  padding: 10px;\n}\n.product-detail > img {\n  height: 200px;\n  padding: 10px;\n}\n.tags {\n  /* height: 20px; */\n  background-color: #eaeaea;\n  color: black !important;\n  /* min-width:50px; */\n  /* width: auto; */\n  padding: 0px 10px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: bold;\n  margin: 4px 2px;\n}\n.add-image > span {\n  color: grey;\n}\n.add-image.active > button {\n  width: 100px;\n  height: 23px;\n  border-radius: 6px;\n  background-color: var(--rf-brand-lite);\n  color: white;\n  border: none;\n  padding: 0;\n}\n.add-image.active {\n  background-color: white;\n}\n.add-image > div > img {\n  height: 300px;\n}\n.add-image {\n  background-color: #f2f0f0;\n  height: 300px;\n  aspect-ratio: 2/1;\n}\n.newcode {\n  background-color: var(--rf-brand-lite);\n  color: white;\n  font-weight: bold;\n  padding: 5px 15px;\n}\n.popup-window > .action-btns {\n  position: absolute;\n  bottom: 0;\n}\n.popup-window {\n  width: 500px;\n  min-height: 300px;\n  background: white;\n}\n.blur-bg {\n  backdrop-filter: blur(2px);\n}\n.fullscreen {\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n}\n.popup.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 99;\n}\n.collapsable-user-display.active {\n  height: 150px;\n}\n.collapsable-user-display > div > img {\n  height: 60px;\n  border-radius: 50%;\n}\n.collapsable-user-display {\n  width: 100%;\n  height: 60px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n  margin-top: 10px;\n}\n.collapsable-user-display > .user-detail {\n  min-height: 50px;\n  width: 100%;\n}\n.collapsable-user-display > .user-detail > p {\n  margin-top: 20px !important;\n}\n.collapsable-user-display > .user-detail > div > div {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: left;\n}\n.checker_img {\n  width: 90px;\n}\n\n.pagenation {\n  width: 100%;\n  height: 24px;\n  margin-top: -50px;\n  position: relative;\n}\n\n.pagenation > div > div.page-btn:hover {\n  background: #dfc48a;\n}\n.pagenation > div > div.page-btn.active {\n  background: #6a6a6a;\n}\n.pagenation > div > div.page-btn {\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  background-color: #b7b7b7;\n  margin: 0px 0px;\n  color: white;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--font-small);\n  margin: 0px 2px;\n  border-radius: 50%;\n}\n.next,\n.prev {\n  cursor: pointer;\n  width: 5%;\n  background-color: #6a6a6a;\n  color: white;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.pagenation > .pages {\n  width: 90%;\n}\n.wo-filter-tools > div {\n  margin: 5px 3px;\n}\n.wo-filter-tools {\n  width: var(--width-lg25-md50-lg-100);\n}\n\n.drag-drop-area > div.action {\n  position: absolute;\n  right: 0;\n  top: 0px;\n  height: 40px;\n  margin-right: 5px;\n}\n\n.drag-drop-area > div.action > button {\n  border: none;\n  background-color: #66b755;\n  padding: 3px 10px;\n  color: white;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);\n  height: 40px;\n  margin-right: 30px;\n}\n.drag-drop-area.detail {\n  width: 100%;\n  position: relative;\n}\n.drag-drop-area.movable {\n  width: var(--side-slide-width);\n  position: absolute;\n}\n.drag-drop-area {\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25) !important;\n  /* overflow: hidden; */\n  /* top: 80px; */\n  /* left:40px; */\n  background-color: rgba(255, 255, 255, 1);\n  /* border: 2px dashed #a4a4a4; */\n  min-height: calc(100vh - 100px);\n  z-index: 99;\n  border-radius: 10px;\n  width: 100%;\n  /* padding: 0 10px; */\n}\n.drag-drop-area > div > .body {\n  height: calc(100vh - 250px);\n}\n.drag-drop-area > div > div > .head.page {\n  font-size: var(--font-xbig);\n}\n.drag-drop-area > div > div > .head {\n  font-size: var(--font-small);\n  height: 40px;\n  width: 100%;\n  font-weight: bold;\n  background-color: #6a6a6a;\n  color: white;\n  margin-bottom: 20px;\n}\n.delivery-run-row.head {\n  height: auto !important;\n  min-height: 25px !important;\n  background-color: #8e8e8e;\n  color: white;\n  margin-top: 20px;\n}\n.delivery-run-row.touchable:hover {\n  background: #f6e9cc;\n}\n\n.delivery-run-row.delete {\n  opacity: 0;\n  background: red !important;\n}\n.delivery-run-row.print {\n  border-bottom: 1px solid black;\n}\n.delivery-run-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 10px;\n  background: white;\n  opacity: 1;\n  transition: \n  /* step 1 */ background 1s, /* step 2 */ opacity 0.5s 1s;\n}\n.delivery-run-row > span {\n  text-align: center;\n}\n.delivery-run-row > span:nth-child(1) {\n  width: 1%;\n}\n.delivery-run-row > span:nth-child(2) {\n  width: 8%;\n}\n.delivery-run-row > span:nth-child(3) {\n  width: 15%;\n}\n.delivery-run-row > span:nth-child(4) {\n  width: 8%;\n}\n.delivery-run-row > span:nth-child(5) {\n  width: 15%;\n}\n.delivery-run-row > span:nth-child(5) {\n  width: 20%;\n}\n.delivery-run-row > span:nth-child(6) {\n  width: 5%;\n}\n\n.delivery-run-row.detail > span:nth-child(1) {\n  width: 10px;\n}\n.delivery-run-row.detail > span:nth-child(2) {\n  width: 5%;\n}\n.delivery-run-row.detail > span {\n  width: 10%;\n  font-size: var(--font-small);\n}\n.delivery-run-row.detail.print > span {\n  width: 10%;\n  font-size: var(--font-prints);\n}\n.delivery-run-row.detail > span:nth-child(10) {\n  width: 15%;\n}\n\n.delivery-run-row.fd-list > span:nth-child(1) {\n  width: 1%;\n}\n.delivery-run-row.fd-list > span:nth-child(2) {\n  width: 8%;\n}\n.delivery-run-row.fd-list > span:nth-child(3) {\n  width: 8%;\n}\n.delivery-run-row.fd-list > span:nth-child(4) {\n  width: 10%;\n}\n.delivery-run-row.fd-list > span:nth-child(5) {\n  width: 10%;\n}\n.delivery-run-row.fd-list > span:nth-child(6) {\n  width: 10%;\n}\n.delivery-run-row.fd-list > span:nth-child(7) {\n  width: 10%;\n}\n.delivery-run-row.fd-list > span:nth-child(8) {\n  width: 10%;\n}\n.delivery-run-row.fd-list > span:nth-child(9) {\n  width: 20%;\n}\n.delivery-run-row.fd-list > span:nth-child(10) {\n  width: 5%;\n}\n\n.inventory-run-row.head {\n  height: 25px !important;\n  background-color: #8e8e8e;\n  color: white;\n  margin-top: 20px;\n}\n\n.inventory-run-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 10px;\n  background: white;\n  opacity: 1;\n  transition: \n    /* step 1 */ background 1s, /* step 2 */ opacity 0.5s 1s;\n}\n.inventory-run-row > span:nth-child(1) {\n  width: 3%;\n}\n.inventory-run-row > span:nth-child(2) {\n  width: 65%;\n}\n.inventory-run-row > span:nth-child(3) {\n  width: 20%;\n}\n\n.tooltip-prompt > .corner {\n  position: absolute;\n  left: 139px;\n  bottom: -10px;\n  z-index: 0;\n  height: 20px;\n  aspect-ratio: 1/1;\n  background: var(--rf-brand-lite);\n  transform: rotate(45deg);\n}\n.tooltip-prompt {\n  position: fixed;\n  top: 80px;\n  width: 300px;\n  background-color: white;\n  border-radius: 6px;\n  z-index: 99;\n}\n.tooltip-prompt > div.msg {\n  padding: 10px;\n  text-align: center;\n  background-color: var(--rf-brand-lite);\n  color: white;\n}\n.tooltip-prompt > div > button:hover {\n  background-color: #86c579;\n  color: white;\n}\n.tooltip-prompt > div > button {\n  background-color: white;\n  border: none;\n  width: 50%;\n  padding: 8px 10px;\n  position: relative;\n  z-index: 10;\n}\n\n.expanding-prompt > div.opts {\n  width: 50%;\n  transition: 1000ms;\n  opacity: 0.5;\n  position: relative;\n  z-index: 3;\n}\n.expanding-prompt > div.opts.active {\n  opacity: 1;\n  transition: 1000ms;\n  width: auto;\n}\n.expanding-prompt {\n  position: fixed;\n  top: 80px;\n  background-color: white;\n  border-radius: 6px;\n  overflow: hidden;\n  width: 300px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.expanding-prompt > div.msg {\n  padding: 10px;\n  text-align: center;\n  background-color: #6a6a6a;\n  color: white;\n}\n.expanding-prompt > div > button:hover {\n  background-color: #86c579;\n  color: white;\n}\n.expanding-prompt > div > button {\n  background-color: rgb(255, 248, 232);\n  border: none;\n  padding: 8px 30px;\n}\n.loading-div {\n  width: 98%;\n  height: 30px;\n  margin: 3px 1%;\n}\n\n.run-detail.active > div {\n  box-shadow: -50px -2px 180px rgba(0, 0, 0, 0.2) !important;\n}\n\n.run-detail.active {\n  right: 0;\n  transition: 300ms;\n  top: 0;\n  opacity: 1;\n}\n\n.run-detail {\n  position: absolute;\n  right: -100%;\n  top: 0;\n  transition: 300ms;\n  opacity: 0;\n}\n.loading-wait {\n  width: 40px !important;\n}\n.wait-box {\n  border-radius: 50%;\n  background-color: white;\n  aspect-ratio: 1/1;\n  animation: wait 1s infinite;\n}\n@keyframes wait {\n  from {\n    width: 3px;\n  }\n  to {\n    width: 6px;\n  }\n}\n.reload-display {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  height: 200px;\n  margin-top: 50px;\n}\n\n@media print {\n  .print-page {\n    left: 0 !important;\n    width: 100% !important;\n    margin: 0px !important;\n  }\n  .the-print-page {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  .no-print,\n  .no-print * {\n    display: none !important;\n  }\n}\n\n.print-page {\n  position: absolute;\n  left: 5%;\n  top: 5px;\n  width: 90%;\n  /* aspect-ratio: 1.4142/1; */\n  /* aspect-ratio: 1/1; */\n  min-height: calc(100vh - 100px);\n  background-color: white;\n  /* z-index: 100; */\n  font-size: var(--font-small);\n}\n.print-page > div > div > div > div.head.page > span.date {\n  height: 40px;\n  min-width: 200px;\n  padding: 0px 10px;\n  color: black;\n  margin-left: 35px;\n  background-color: white;\n}\n.print-page > div > div > div > .head {\n  border-radius: 30px 0px 0px 15px !important;\n  /* overflow: hidden; */\n  height: 40px;\n  background-color: #6a6a6a;\n  color: white;\n  font-weight: bold;\n  font-size: var(--font-big);\n}\n.run-details {\n  width: 100%;\n  height: 60px;\n  margin: 0px 10px;\n}\nspan.text-description {\n  min-height: 30px;\n  width: 100%;\n  margin-bottom: 1px;\n  background-color: #fafafa;\n}\nspan.text-description > bold {\n  height: 30px;\n  width: 150px;\n  color: black;\n  background: #e7e7e7;\n  margin-right: 20px;\n}\n.product-content.selector {\n  min-height: 400px;\n}\n.product-content {\n  min-height: 750px;\n  /* display: flex; */\n  /* flex-direction: column; */\n  /* justify-content: space-between; */\n  margin-bottom: 50px;\n}\n.profile-view {\n  background-color: white;\n  border-radius: 50%;\n  position: relative;\n}\n.profile-view > img {\n  height: calc(var(--header-height) - 10px);\n  width: calc(var(--header-height) - 10px);\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid white;\n}\n.profile-view > .profile-detail {\n  /* display: none; */\n  position: absolute;\n  right: 0;\n  width: 150px;\n  height: 70px;\n  background: white;\n  padding: 5px;\n  border-radius: 5px;\n  /* transition: 500ms; */\n}\n\n.error-label-message {\n  width: 100%;\n  padding: 10px 5px;\n  background-color: white;\n  text-align: center;\n  border-bottom: 2px solid red;\n}\n.popup-alert.grey-bg {\n  background-color: #525659 !important;\n}\n.label-info-edit.active {\n  right: -340px;\n  /* transform: rotate(0deg);\n  transform-origin: 0 0; */\n  opacity: 1;\n\n  transition: 250ms;\n  background-color: white;\n}\n.label-info-edit {\n  /* transition: 1s ease-in-out 500ms; */\n  /* transform: rotate(90deg); */\n  /* transform-origin: 0 0; */\n  position: absolute;\n  right: 0px;\n  top: 0;\n  min-height: 100px;\n  min-width: 300px;\n  opacity: 0;\n  background: none;\n  z-index: 5;\n  border-radius: 0 8px 8px 8px !important;\n}\n\n.label-info-edit-body > span {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  padding: 10px 17px;\n  background-color: #71777b;\n  color: white;\n  font-weight: bold;\n  border-radius: 0 8px;\n}\n.label-info-edit-body {\n  margin-top: 50px;\n  float: right;\n  padding: 10px 20px 10px 30px;\n  width: 350px;\n}\n.popup-alert.large {\n  min-height: 300px;\n}\n.popup-alert {\n  min-height: 100px;\n  min-width: 400px;\n\n  background-color: white;\n  z-index: 99;\n  margin-top: 50px;\n}\n\n.size-content > .head {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n}\n.size-content > .contents > span > span.amount {\n  color: black;\n  font-weight: normal;\n  float: right;\n}\n.size-content > .contents {\n  background-color: #eaeaea;\n  max-height: 200px;\n  overflow-y: scroll;\n}\n.size-content > .contents > span {\n  color: var(--rf-brand-lite);\n  font-weight: bold;\n  width: 100%;\n  font-size: var(--font-medium);\n  border-bottom: 1px solid white;\n  margin: 2px 0;\n}\n.size-content > .head > span {\n  padding: 4px 10px;\n  font-size: var(--font-medium);\n  cursor: pointer;\n  text-align: center;\n  color: #6a6a6a;\n}\n.size-content > .head > span.active {\n  background-color: #888787;\n  color: white;\n}\n.size-content > .head > span.active > span {\n  font-size: var(--font-big);\n  font-weight: bold;\n  background-color: white;\n  color: var(--rf-brand-lite);\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);\n  padding: 8px 15px;\n  margin-right: -15px;\n  margin-left: 10px;\n  /* border-radius: 10px 0; */\n}\n.related-list {\n  border-radius: 1px solid black !important;\n  border-bottom: 1px solid var(--rf-brand-lite);\n  padding: 2px 5px;\n}\n\n.related-list:hover {\n  background-color: #f8e6be !important;\n}\n.loading-spin {\n  border-radius: 50%;\n  border-bottom: 2px solid var(--rf-brand-lite);\n  animation: loading 500ms linear infinite;\n}\n.loading-spin.white {\n  border-bottom: 2px solid white !important;\n}\n.loading-spin.red {\n  border-bottom: 2px solid rgb(210, 116, 116) !important;\n}\n.loading-spin.small {\n  width: 15px;\n  height: 15px;\n}\n.loading-spin.large {\n  width: 50px;\n  height: 50px;\n}\n\n@keyframes loading {\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.collapsable-hor {\n  width: 400px;\n  margin-left: 20px;\n}\n.collapsable-hor > span {\n  height: 30px;\n  width: auto;\n  margin-bottom: 10px;\n  padding: 10px 0px;\n  /* color: white; */\n  font-size: var(--font-medium);\n}\n.work-order-tooltip {\n  position: absolute;\n  left: 50px;\n  min-height: 30px;\n  min-width: 200px;\n  background-color: white;\n  border-radius: 5px;\n  z-index: 99;\n  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.2);\n}\n.work-order-tooltip > .body > .title {\n  background-color: white;\n  color: #c48650;\n  height: auto !important;\n  /* box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.2); */\n  margin-bottom: 10px;\n  text-align: center;\n  padding: 5px !important;\n  border-radius: 0 5px 0 0;\n}\n.work-order-tooltip > .body > span {\n  padding: 3px 30px !important;\n  height: auto;\n  display: block;\n  /* width: 100% !important; */\n}\n.work-order-tooltip > .body {\n  border-radius: 5px;\n  z-index: 99;\n  position: absolute;\n  width: 100%;\n  min-height: 30px;\n  background-color: white;\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;\n}\n.work-order-tooltip > .edge {\n  background-color: var(--rf-brand-lite);\n  position: absolute;\n  top: 5px;\n  left: -9.5px;\n  height: 20px;\n  width: 20px;\n  transform: rotate(45deg);\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;\n}\n.list-num {\n  position: absolute;\n  left: -30px;\n}\n.option-list {\n  width: 100%;\n  display: flex;\n  /* border: 1px solid grey; */\n  flex-direction: column;\n  margin-top: -10px;\n}\n.option-list > div {\n  font-weight: bold;\n  text-align: center;\n  /* background-color: #6a6a6a; */\n  /* color: white; */\n  padding: 4px;\n  font-size: var(--font-medium);\n}\n.option-list > span {\n  padding: 2px 10px;\n  font-size: 12px;\n  width: 100%;\n  cursor: pointer;\n  /* background-color: white; */\n  margin-bottom: 1px;\n}\n.option-list > span:hover {\n  /* background-color: #c0c0c0; */\n  /* color: white; */\n}\n.border-left-1 {\n  border-left: 1px solid grey;\n}\n\n/* library css modifications */\n.react-datetime-picker__wrapper {\n  border: none !important;\n}\n.react-datetime-picker__calendar-button {\n  width: 40px !important;\n}\n.react-calendar__navigation {\n  background-color: var(--rf-brand-lite) !important;\n}\n.react-calendar__navigation > button {\n  color: white !important;\n  font-weight: bold;\n}\n.react-calendar__navigation > button:hover {\n  background-color: #d9b465 !important;\n}\n\n.profit-modal-open > .profit-display {\n  /* width: 30%; */\n  border-radius: 10px;\n  overflow: hidden;\n}\n.profit-modal-open {\n  transition: 500ms;\n  position: absolute;\n  width: 100%;\n  height: 800px;\n  left: 0px;\n  top: -80px;\n  z-index: 100;\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.3);\n  background: white;\n  padding: 20px 10px;\n}\n\n.profit-display {\n  height: 100px;\n  width: 100%;\n}\n.profit-display > div {\n  width: 50%;\n}\n.profit-display > div > span.amount {\n  /* display: block; */\n  font-size: 30px !important;\n  font-weight: bold;\n  height: 70px;\n  width: 100%;\n}\n.profit-display > div > span.text {\n  /* display: block; */\n  font-weight: bold;\n  height: 30px;\n  width: 100%;\n  font-size: 11px;\n}\n.count-display {\n  width: 100%;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.card-number {\n  width: auto;\n  height: 100px;\n  margin: 0px 3px !important;\n}\n.card-number.small {\n  height: 75px;\n}\n.card-number.small > span.count {\n  height: 60px;\n  font-size: 25px;\n}\n.card-number > span.count > .side {\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 15px;\n  width: 30px;\n  height: 55px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.card-number > span.count.large {\n  font-size: 60px;\n}\n.card-number > span.count {\n  color: var(--rf-brand-lite);\n  height: 80px;\n  font-size: 40px;\n}\n.card-number.small > .text {\n  height: 15px;\n  font-size: 10px;\n}\n.card-number > .text {\n  color: white;\n  background-color: #b79800;\n  height: 20px;\n  font-size: 11px;\n}\n.progress-div {\n  width: 100%;\n  height: 25px;\n  background: #eaeaea !important;\n  margin-top: 2px;\n}\n.progress-div > div.bar {\n  display: flex;\n  justify-content: space-between;\n  height: 5px;\n  background-color: var(--rf-brand-lite);\n}\n.progress-div > div.bar > span {\n  height: 25px;\n  color: #48484a;\n  font-weight: bold;\n  font-size: 11px;\n  padding: 0px 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 3px;\n}\n\n.notification-board > .head {\n  width: 100%;\n  background: #848484;\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  padding: 4px 0px;\n  text-align: center;\n}\n\n.notif-bar {\n  height: 40px;\n  background: #e5e5e5;\n  margin-top: 1px;\n}\n.notif-icon.red > svg {\n  /* color: #e77171; */\n}\n.notif-icon {\n  background-color: #aaa9a9;\n  display: flex;\n  width: 40px;\n  height: 40px;\n}\n.notif-text {\n  padding: 0px 15px;\n  font-size: 11px;\n}\n.title-separator.xsmall {\n  height: 10px;\n  margin-bottom: 5px;\n}\n.title-separator.xsmall > .text {\n  font-size: 8px;\n}\n\n.title-separator.push-top {\n  margin-top: 30px;\n}\n.title-separator {\n  width: 100%;\n  height: 20px;\n  margin-bottom: 10px;\n}\n.title-separator > .line {\n  border-top: 1px solid #6a6a6a;\n  height: 3px;\n  width: 100%;\n}\n.title-separator > .text {\n  position: absolute;\n  left: 20px;\n  background: white;\n  width: auto !important;\n  padding: 0px 10px;\n  font-weight: bold;\n  font-size: 11px;\n}\n.detailed-progress-bar {\n  display: flex;\n  align-items: end;\n  width: 100%;\n  background-color: white;\n  height: 25px;\n  margin-top: 20px;\n}\n.detailed-progress-bar > div > .bar.low {\n  background: #d17272;\n}\n.detailed-progress-bar > div > .bar.mid {\n  background: #d1cb72;\n}\n.detailed-progress-bar > div > .bar.high {\n  background: #7dd172;\n}\n.detailed-progress-bar > div > .bar {\n  height: 5px;\n  /* background: #d19e72; */\n}\n.detailed-progress-bar > div > .bar > .counter {\n  /* display: block; */\n  width: 35px;\n  /* background-color: #97704d; */\n  color: black;\n  border-radius: 0px 5px 5px 0px;\n  height: 25px;\n  font-size: 11px;\n  position: absolute;\n  right: 5px;\n  top: -20px;\n}\n\n.bar-count {\n  width: 40%;\n  background-color: #f4f2f2;\n  /* padding-left: 10px; */\n  height: 25px !important;\n  border-right: 1px solid gray;\n}\n.bar-count > span {\n  padding-left: 10px;\n}\n.bar-count > span > .number {\n  font-size: 22px;\n  font-weight: bold;\n  /* position: absolute;\n  left: 0px;\n  bottom: 10px; */\n  margin-right: 5px;\n  color: #97704d;\n}\n.bar-count > span > .txt {\n  font-size: 11px;\n  color: var(--rf-brand-lite);\n}\nbutton.print-btns.active {\n  background-color: #f1d9a6;\n  color: #fff;\n}\nbutton.print-btns {\n  font-size: 12px;\n  /* font-weight: bold; */\n  margin-bottom: -5px;\n  margin-left: 5px;\n  /* border: 0px; */\n  border: 1px solid #c6c6c6;\n  height: 30px;\n  min-width: 150px;\n  padding: 0px 30px;\n  color: var(--rf-brand-lite);\n  border-radius: 3px;\n}\n.printer-panel > input {\n  padding: 5px 0px;\n  /* display: block; */\n  width: 50px;\n  height: 20px;\n  text-align: center;\n  font-size: 11px !important;\n}\n.printer-panel {\n  background: white;\n  width: 100%;\n  height: 50px;\n  z-index: 100;\n  /* border-radius: 0px 0px 25px 25px; */\n}\n\n.div-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 5px 5px;\n  background: #6a6a6a;\n  color: white;\n  font-size: var(--font-small);\n}\n.dashboard-btn {\n  position: absolute;\n  left: 300px;\n  width: 150px;\n  background: var(--rf-brand-lite);\n  padding: 7px 10px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n.counter-div {\n  width: 20px;\n  aspect-ratio: 1/1;\n  border-radius: 50%;\n  background: #009688;\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  margin-left: 10px;\n  position: absolute;\n  right: -10%;\n}\n.calendar-page-picker {\n  /* height: 30px; */\n  background-color: white;\n  width: 100% !important;\n  margin-bottom: 5px;\n  /* overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap; */\n  padding: 0px 25px;\n  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.25);\n}\n.calendar-page-picker > span.btns {\n  width: 20px !important;\n  height: 25px;\n  background-color: white;\n  padding: 0px 3px;\n}\n.calendar-page-picker > span:hover {\n  color: var(--rf-brand-lite) !important;\n}\n.calendar-page-picker > span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* padding: 5px 23px; */\n  font-weight: bold;\n  height: 25px;\n  cursor: pointer;\n  width: 103px;\n  font-size: 11px;\n  /* background-color: white; */\n  /* box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.25); */\n}\n.calendar-page-picker > span.selected {\n  color: var(--rf-brand-lite) !important;\n  font-size: 12px;\n  margin-top: -10px;\n  background-color: white;\n  border-bottom: 2px solid var(--rf-brand-lite);\n  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.date-picker-slider {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.date-slider {\n  display: flex;\n  flex-wrap: nowrap;\n  transition: transform 0.3s ease;\n  cursor: pointer;\n}\n\n.date-slider-item {\n  min-width: 120px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n  margin-right: 8px;\n}\n\n.date-slider-item.selected {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.nav-buttons {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n}\n\n.nav-buttons button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 0 4px;\n}\n\n.nav-buttons button:hover {\n  background-color: #0056b3;\n}\n\n.ver-nav {\n  width: 20%;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n}\n.ver-nav > span {\n  padding: 5px 10px;\n  cursor: pointer;\n  margin-bottom: 4px;\n  box-shadow: 0px 3px 8px rgba(142, 139, 139, 0.1);\n}\n.ver-nav > span:hover {\n  color: #f6efdf;\n}\n.ver-nav > span.selected {\n  color: #f3ca71;\n  font-weight: bold;\n}\n.wage-input {\n  height: 20px;\n  border: 1px solid rgb(189, 189, 189);\n  width: 80px;\n  /* background-color: red; */\n}\n\n.order-titles {\n  width: 100%;\n  padding: 4px 10px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #009688;\n  box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.25);\n  background: white;\n}\n.pulsing-div {\n  height: 1000px;\n  width: 1000px;\n  background: radial-gradient(\n    circle,\n    rgba(245, 245, 245, 1) 0%,\n    rgba(190, 189, 189, 1) 2%,\n    rgba(245, 245, 245, 1) 3%\n  );\n}\n.pulsing-div.wide {\n  background: radial-gradient(\n    circle,\n    rgba(245, 245, 245, 1) 0%,\n    rgba(190, 189, 189, 1) 50%,\n    rgba(245, 245, 245, 1) 90%\n  );\n}\n.page-date-display {\n  height: 35px;\n  /* width: 80%; */\n  background-color: white;\n  padding: 0 60px;\n  /* position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 99; */\n  margin-bottom: 5px;\n  overflow: hidden;\n  color: var(--rf-brand-lite);\n}\n\n.side.card-side-wedge {\n  transform: rotate(45deg);\n  position: absolute;\n  left: -20px;\n  top: 0;\n  width: 35px;\n  height: 35px;\n  background-color: var(--rf-brand-lite);\n}\n\n.short-price > span {\n  padding: 5px 10px !important;\n  width: 100%;\n  /* font-weight: bold; */\n  text-align: left;\n}\n.short-price {\n  padding-left: 10px;\n  background-color: #f1e9d9;\n  color: black;\n  /* border-radius: 6px; */\n  border: 1px dashed rgb(168, 168, 168);\n  /* height: 40px; */\n}\n.border-right {\n  border-right: 1px solid rgb(168, 168, 168);\n  padding-left: 10px;\n}\n\n.removable-tag-list.cc-edit:hover {\n  background: #f4f4f4;\n}\n.removable-tag-list.cc-edit {\n  background: #e0dfdf;\n  cursor: pointer;\n}\n.removable-tag-list {\n  /* background: #66B755; */\n  /* color: white; */\n  border-radius: 5px;\n  padding: 5px 10px;\n  font-size: 11px;\n  /* width: 100px; */\n  margin: 4px 2px;\n  /* position: absolute; */\n}\n\n.block {\n  border: 1px solid #e1e1e1;\n  border-radius: 8px;\n  padding: 0px 18px !important;\n}\nheader.golden-card {\n  background: #f5f5f5;\n  color: var(--rf-brand-lite);\n  padding: 4px 0px;\n}\n.form-button {\n  width: 30px;\n  height: 30px;\n  background-color: #d16b6b;\n  color: white;\n  cursor: pointer;\n  padding: 5px;\n}\n.report-container > .report-header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.report-container > .report-body {\n  display: flex;\n  flex-direction: column;\n  padding-left: 20px;\n  margin: 10px 0px 0px 40px;\n  border-left: 2px solid #009688;\n}\n.print-label > p.label-row {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  /* border: 1px solid grey; */\n}\n.print-label.printed {\n  background-color: #ceffbd;\n}\n.print-label-img {\n  width: 384px;\n  height: 192px;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n.print-label-img > .text {\n  position: absolute;\n  color: #fe803d;\n}\n.print-label {\n  position: relative;\n  background-color: white;\n  border-radius: 4px;\n  width: 384px;\n  height: 192px;\n  /* font-size: 16px; */\n  padding: 20px 20px;\n  font-family: Arial;\n  font-style: italic;\n  font-weight: 450;\n  overflow: hidden;\n  padding: 0px;\n}\n.overlay-loading {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n\n/* HTML: <div class=\"loader\"></div> */\n.loader {\n  width: 88px;\n  height: 10px;\n  --_g: no-repeat radial-gradient(farthest-side, #efd6a0 94%, #0000);\n  background: var(--_g) 25% 0, var(--_g) 75% 0;\n  background-size: 10px 10px;\n  /* position: relative; */\n  animation: l24-0 0.8s linear infinite;\n}\n.loader:before {\n  content: \"\";\n  position: absolute;\n  height: 10px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: #efd6a0;\n  inset: 0;\n  margin: auto;\n  animation: l24-1 0.8s cubic-bezier(0.5, 300, 0.5, -300) infinite;\n}\n@keyframes l24-0 {\n  0%,\n  24% {\n    background-position: 25% 0, 75% 0;\n  }\n  40% {\n    background-position: 25% 0, 85% 0;\n  }\n  50%,\n  72% {\n    background-position: 25% 0, 75% 0;\n  }\n  90% {\n    background-position: 15% 0, 75% 0;\n  }\n  100% {\n    background-position: 25% 0, 75% 0;\n  }\n}\n@keyframes l24-1 {\n  100% {\n    transform: translate(0.1px);\n  }\n}\n\n.runsheet-card {\n  width: 300px;\n  min-height: 100px;\n  border-radius: 8px;\n  overflow: hidden;\n  margin: 0px 2px;\n}\n.runsheet-card > .body {\n  padding: 5px;\n}\n.runsheet-card > .body > span > span {\n  text-align: left;\n}\n.runsheet-card > .head {\n  height: 30px;\n  width: 100%;\n  font-weight: bold;\n  line-height: 30px;\n  padding-left: 10px;\n  text-align: left;\n  color: white;\n  /* background-color: red; */\n}\n\n.row-tag .name {\n  font-size: 14px;\n  color: white;\n  width: 100%;\n}\n.row-tag:hover {\n  z-index: 101 !important;\n}\n.row-tag {\n  transform: rotate(90deg);\n  position: absolute;\n  height: 30px;\n  width: 200px;\n  left: 0px;\n  top: 0px;\n  transform-origin: 0% 0%;\n  border-radius: 0px 0px 10px 10px;\n}\n.date-range-picker {\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n.hor-list-selector > span.active {\n  background-color: #efefef;\n  color: #b79800;\n}\n.hor-list-selector > span:hover {\n  background-color: #e1e1e1;\n  color: #b79800;\n}\n.hor-list-selector > span {\n  font-size: 10px;\n  color: white;\n  font-weight: bold;\n  background-color: #7c7c7c;\n  padding: 4px 20px;\n  border-right: 1px solid white;\n  text-align: center;\n  cursor: pointer;\n}\n.flex-grow {\n  flex-grow: 100;\n}\n.datetime-range-picker {\n  /* background-color: red; */\n  width: 300px;\n  height: 35px;\n  margin-left: 10px;\n}\n.datetime-range-picker > .calenders.active {\n  display: flex;\n}\n.cale-btns {\n  margin: 0px 5px;\n  cursor: pointer;\n}\n.printer-dropdown-item:hover {\n  background-color: #f5f5f5 !important;\n  cursor: pointer;\n}\n\n.pick-btn {\n  padding: 5px 20px;\n}\n\n/* entry animation  */\n\n/* .sqe-3 */\n\n@media {\n  :root {\n    --translate-offset: -300px;\n    --scale-by: 0.9;\n  }\n}\n\n@keyframes fadeInToLeft {\n  0% {\n    opacity: 0;\n    right: var(--translate-offset);\n    transform: scale(var(--scale-by));\n  }\n  70% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n    right: 0px;\n  }\n}\n@keyframes fadeInToRight {\n  from {\n    opacity: 0;\n    left: var(--translate-offset);\n    transform: scale(var(--scale-by));\n  }\n  70% {\n    transform: scale(0.95);\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n    left: 0px;\n  }\n}\n\n@keyframes zoomIn {\n  from {\n    opacity: 0;\n    /* transform: scale(var(--scale-by)); */\n  }\n  to {\n    opacity: 1;\n    /* transform: scale(1); */\n  }\n}\n\n.zoom-in {\n  /* animation: zoomIn 1s forwards; */\n}\n\n.in-animation-to-left {\n  position: relative;\n  height: 600px;\n  width: 100%;\n  /* animation: fadeInToLeft 1s forwards; */\n}\n\n.in-animation-to-right {\n  position: relative;\n  height: 600px;\n  width: 100%;\n  /* animation: fadeInToRight 1s forwards; */\n}\n.full-modal {\n  width: 100% !important;\n  z-index: 10;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 700px;\n}\n.small-table-row > td,\nth {\n  padding: 2px 10px !important;\n}\n.ordered-list-table {\n  max-height: 700px;\n  overflow-y: scroll;\n}\n\n/* For webkit-based browsers */\n.thin-red-scrollbar::-webkit-scrollbar {\n  width: 4px; /* Width of the scrollbar */\n  height: 4px; /* Height of the scrollbar */\n}\n\n.thin-red-scrollbar::-webkit-scrollbar-track {\n  background: transparent; /* Background of the scrollbar track */\n}\n\n.thin-red-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #f0d499; /* Color of the scrollbar thumb */\n  border-radius: 5px; /* Rounded corners of the scrollbar thumb */\n  border: 2px solid transparent; /* Adds space around thumb */\n}\n\n/* For Firefox */\n.thin-red-scrollbar {\n  scrollbar-width: thin; /* Makes the scrollbar thin */\n  scrollbar-color: #f0d499 transparent; /* Color of the thumb and track */\n}\n\n.small-tag {\n  color: white;\n  padding: 0px 10px;\n  background: #a6a5a5;\n  border-radius: 5px;\n}\n.large-lable {\n  padding: 5px 20px;\n  border: 1px solid grey;\n  font-weight: bold;\n}\n.header-small {\n  background: #eaeaea;\n  padding-left: 5px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.border-gold {\n  border: 2px solid #b79800;\n}\n.border-grey {\n  border: 1px solid #6a6a6a;\n}\n.circle {\n  border-radius: 50%;\n  padding: 2px;\n  /* height: 20px !important; */\n  aspect-ratio: 1/1;\n}\n.wedget-header {\n  border-radius: 8px 8px 0px 0px;\n  font-size: 16px;\n  color: white;\n  background: #6a6a6a;\n  padding: 4px 12px;\n}\n.progress-fields {\n  background-color: #55b79e !important;\n  font-weight: normal;\n  font-size: 11px;\n  /* display: flex; */\n  /* align-items: center; */\n}\n.justify-end {\n  display: flex;\n  justify-content: end;\n}\n.float-right {\n  float: right;\n}\n.float-left {\n  float: left;\n}\n.no-shaodw {\n  box-shadow: none !important;\n}\n.light-border {\n  border: 1px solid rgb(230, 230, 230) !important;\n}\n\n/*\n.pop-overlay.left{\n  left: 0; \n}\n.pop-overlay.right{\n  right: 0; \n}\n.pop-overlay{\n  position:absolute; \n  top: 0; \n  height:85vh;\n  width: 40%;\n  background: white;\n  z-index:100;\n  padding: 10px;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);\n}\n*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
